export interface Product {
  id: string;
  code: string;
  name: string;
  nameZh: string;
  category: '탕류' | '해조류' | '음료·두유' | '차류' | '스낵·김' | '생활용품' | '김치·반찬' | '스킨케어·뷰티' | '섬유향수' | '운동화' | '건강용품' | '핸드크림';
  image: string;
  unitPrice: number;
  retailPrice?: number;
  boxQuantity: number;
  boxPrice: number;
  specification: string;
  specificationZh: string;
  expiryInfo: string;
  expiryInfoZh: string;
  storageMethod: string;
  storageMethodZh: string;
  barcode: string;
  tags: Array<'recommended' | 'lowest' | 'popular'>;
  badge?: string;
  badgeZh?: string;
  origin: string;
  originZh: string;
  description?: string;
  descriptionZh?: string;
  keyFeatures?: Array<{ icon: string; titleKo: string; titleZh: string; descKo: string; descZh: string }>;
  // 섬유향수 전용 가격 구조
  consumerPrice?: number;      // 소비자가격 (元)
  onlinePrice?: number;        // 온라인가격 (元)
  livePrice1?: number;         // 라이브 방송 특가 1병 (元)
  livePrice3?: number;         // 라이브 방송 특가 3병 (元)
  // 핸드크림 세트 전용 가격 구조
  hcRetailPrice?: number;      // 일상 소매가 (元)
  hcLivePrice1?: number;       // 라이브 특가 1지 (元)
  hcLivePrice3?: number;       // 라이브 특가 3지 (元)
  hcCommission?: number;       // 순수익 커미션 (%)
}

export const products: Product[] = [
  /* ───────── 탕류 ───────── */
  {
    id: 'p1000',
    code: 'No. 1000',
    name: '삼계탕',
    nameZh: '参鸡汤',
    category: '탕류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/a6d48206-c774-4763-a17c-0fe940e1074d_unnamed.png?v=fc0da1a7b3304b1b20a0682b827e364e',
    unitPrice: 26,
    boxQuantity: 10,
    boxPrice: 260,
    specification: '1kg * 10봉/박스',
    specificationZh: '1kg * 10袋/箱',
    expiryInfo: '제조일로부터 18개월',
    expiryInfoZh: '自生产日起18个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '6928211712687',
    tags: ['recommended', 'popular'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '중국산',
    originZh: '中国产',
  },
  {
    id: 'p1001',
    code: 'No. 1001',
    name: '소갈비탕',
    nameZh: '牛排骨汤',
    category: '탕류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/46e42437-5e59-4e25-85b7-a018b5f45617_unnamed.png?v=6276ced7d9e79cf3ead8afb5c1b8c600',
    unitPrice: 27,
    boxQuantity: 20,
    boxPrice: 540,
    specification: '600g * 20봉/박스',
    specificationZh: '600g * 20袋/箱',
    expiryInfo: '제조일로부터 18개월',
    expiryInfoZh: '自生产日起18个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '6928217712694',
    tags: ['recommended', 'popular'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '중국산',
    originZh: '中国产',
  },
  {
    id: 'p1002',
    code: 'No. 1002',
    name: '도가니탕',
    nameZh: '牛筋汤',
    category: '탕류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/33da411c-d332-463a-ada7-19d2ba66b91f_unnamed.png?v=5fadd0cd2b8efa5e2e499891e0d20ba0',
    unitPrice: 24,
    boxQuantity: 20,
    boxPrice: 480,
    specification: '600g * 20봉/박스',
    specificationZh: '600g * 20袋/箱',
    expiryInfo: '제조일로부터 18개월',
    expiryInfoZh: '自生产日起18个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '6928211712731',
    tags: ['lowest'],
    badge: '최저가',
    badgeZh: '最低价',
    origin: '중국산',
    originZh: '中国产',
  },
  {
    id: 'p1003',
    code: 'No. 1003',
    name: '곱창전골',
    nameZh: '牛肠火锅',
    category: '탕류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/d49b8c52-7b56-40f7-8d31-1c2b34eab06a_unnamed.png?v=fbfea78cdd29afbfee01195b18427457',
    unitPrice: 24,
    boxQuantity: 20,
    boxPrice: 480,
    specification: '600g * 20봉/박스',
    specificationZh: '600g * 20袋/箱',
    expiryInfo: '제조일로부터 18개월',
    expiryInfoZh: '自生产日起18个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '6928211712748',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '중국산',
    originZh: '中国产',
  },
  {
    id: 'p1004',
    code: 'No. 1004',
    name: '소꼬리곰탕',
    nameZh: '牛尾汤',
    category: '탕류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/bc6becbe-6b6f-42ea-ba0b-2e4ae3ca6081_unnamed.png?v=cc9aa24a2608481cdf0586fb0f585996',
    unitPrice: 27,
    boxQuantity: 20,
    boxPrice: 540,
    specification: '600g * 20봉/박스',
    specificationZh: '600g * 20袋/箱',
    expiryInfo: '제조일로부터 18개월',
    expiryInfoZh: '自生产日起18个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '6928211712700',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '중국산',
    originZh: '中国产',
  },
  {
    id: 'p1005',
    code: 'No. 1005',
    name: '육개장',
    nameZh: '辣牛肉汤',
    category: '탕류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/188f1372-fe66-4dda-8148-e5d409600f33_unnamed.png?v=5cd28fe51e24e8ddb57defd37b1578a8',
    unitPrice: 15,
    boxQuantity: 20,
    boxPrice: 300,
    specification: '600g * 20봉/박스',
    specificationZh: '600g * 20袋/箱',
    expiryInfo: '제조일로부터 18개월',
    expiryInfoZh: '自生产日起18个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '6928211712755',
    tags: ['lowest'],
    badge: '최저가',
    badgeZh: '最低价',
    origin: '중국산',
    originZh: '中国产',
  },
  {
    id: 'p1011',
    code: 'No. 1011',
    name: '왕갈비탕',
    nameZh: '王排骨汤',
    category: '탕류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/190a6b0d-2fd8-4a20-9854-8bc1a7222ad4_unnamed.png?v=b8c31daa2e45b953797881146526944b',
    unitPrice: 38,
    boxQuantity: 10,
    boxPrice: 380,
    specification: '1200g * 10봉/박스',
    specificationZh: '1200g * 10袋/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '6952109800149',
    tags: ['recommended', 'popular'],
    badge: '프리미엄',
    badgeZh: '精品',
    origin: '중국산',
    originZh: '中国产',
  },

  /* ───────── 해조류 ───────── */
  {
    id: 'fF11a',
    code: 'No.F11',
    name: '푸른정 완도 마른미역 100g',
    nameZh: '福乐正莞岛干裙带菜 100G',
    category: '해조류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/9726b4de-0c9a-47d7-8512-e42aaf901758_1.jpg?v=96f4687b295052ce8a3965d4a9681ff2',
    unitPrice: 13.5,
    boxQuantity: 24,
    boxPrice: 324,
    specification: '100g * 24개/박스',
    specificationZh: '100g * 24个/箱',
    expiryInfo: '제조일로부터 18개월',
    expiryInfoZh: '自生产日起18个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809343509162',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF30a',
    code: 'No.F30',
    name: '푸른정 완도 자른미역 50g',
    nameZh: '福乐正莞岛干裙带菜 50G',
    category: '해조류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/c0278ecd-217b-4b76-8dd0-6cfad0e94c5a_2.jpg?v=71eab4dc689420ea80a70724ec98d217',
    unitPrice: 8.5,
    boxQuantity: 30,
    boxPrice: 255,
    specification: '50g * 30개/박스',
    specificationZh: '50g * 30个/箱',
    expiryInfo: '제조일로부터 18개월',
    expiryInfoZh: '自生产日起18个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809343509209',
    tags: ['lowest'],
    badge: '최저가',
    badgeZh: '最低价',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF108',
    code: 'No.F108',
    name: '맛나 올리브김',
    nameZh: '海朝名家橄榄油海苔',
    category: '해조류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/4a506b83-569e-4630-806a-39c8fd9f3da9_3.jpg?v=a0ff645a6b7ac3c18ae98c71360910c6',
    unitPrice: 16,
    boxQuantity: 10,
    boxPrice: 160,
    specification: '36g * 10개/박스',
    specificationZh: '36g * 10个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809550480339',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF109',
    code: 'No.F109',
    name: '푸른정 완도 올리브김 9p',
    nameZh: '福乐正莞岛橄榄油海苔',
    category: '해조류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/4cd4fee2-120a-4db7-a357-dbd6772d316a_4.jpg?v=6863fb0d08faa83c3f218cb0da486128',
    unitPrice: 16,
    boxQuantity: 10,
    boxPrice: 160,
    specification: '36g * 10개/박스',
    specificationZh: '36g * 10个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809343500817',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF31a',
    code: 'No.F31',
    name: '푸른정 완도조미김 9P',
    nameZh: '福乐正莞岛调味海苔',
    category: '해조류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/c73a1f13-9d34-4322-85ab-50506279d053_5.jpg?v=f22c04d93bd4da8fe56444847be72d2c',
    unitPrice: 15,
    boxQuantity: 10,
    boxPrice: 150,
    specification: '36g * 10개/박스',
    specificationZh: '36g * 10个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8807135900135',
    tags: ['lowest'],
    badge: '최저가',
    badgeZh: '最低价',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF13a',
    code: 'No.F13',
    name: '푸른정 완도조미김 16p',
    nameZh: '福乐正莞岛调味海苔',
    category: '해조류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/2bd57c96-ce38-4d93-b0ad-0e58e13efe2a_6.jpg?v=bbb8cd7aa2014a73619377bc369c64b7',
    unitPrice: 25,
    boxQuantity: 10,
    boxPrice: 250,
    specification: '64g * 10개/박스',
    specificationZh: '64g * 10个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8807135900128',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF106',
    code: 'No.F106',
    name: '엄마손자반 40g',
    nameZh: '福乐正妈妈手调味海苔',
    category: '해조류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/02650dd9-e59f-497f-a86d-77c1eab92c22_7.jpg?v=4220ad12122d1b275f1968a5c91a271d',
    unitPrice: 8,
    boxQuantity: 30,
    boxPrice: 240,
    specification: '40g * 30개/박스',
    specificationZh: '40g * 30个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809343500664',
    tags: ['lowest'],
    badge: '최저가',
    badgeZh: '最低价',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF14a',
    code: 'No.F14',
    name: '푸른정 김밥용김 100장',
    nameZh: '福乐正莞岛包饭用烤海苔',
    category: '해조류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/efd06d8d-b0cc-49a3-9183-2a539bb0b5c0_8.jpg?v=4a66692c35f9c892a6b50b659558a400',
    unitPrice: 75,
    boxQuantity: 20,
    boxPrice: 1500,
    specification: '230g * 20개/박스',
    specificationZh: '230g * 20个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8807135900203',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF11b',
    code: 'No.F11',
    name: '푸른정 염장 쌈다시마',
    nameZh: '福乐正莞岛盐渍海带',
    category: '해조류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/89d6efd7-2d2a-4313-b8c3-e1054af5cc77_9.jpg?v=6f448e7d6f2d0f14b5a828bb8027d4bb',
    unitPrice: 13.5,
    boxQuantity: 24,
    boxPrice: 324,
    specification: '300g * 24개/박스',
    specificationZh: '300g * 24个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '냉장보관',
    storageMethodZh: '冷藏保存',
    barcode: '8809343500718',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF30b',
    code: 'No.F30',
    name: '푸른정 염장미역줄기',
    nameZh: '福乐正莞岛裙带梗丝',
    category: '해조류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/f424225c-5302-4bae-8fc3-30c53a156f72_10.jpg?v=ba491c6ea72d393135fa6247a9172861',
    unitPrice: 13.5,
    boxQuantity: 24,
    boxPrice: 324,
    specification: '300g * 24개/박스',
    specificationZh: '300g * 24个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '냉장보관',
    storageMethodZh: '冷藏保存',
    barcode: '8809343500671',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF12',
    code: 'No.F12',
    name: '푸른정 염장곰피(쌈미역)',
    nameZh: '福乐正莞岛盐渍裙带',
    category: '해조류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/622b9584-f29d-4e45-bfcd-abfb74454311_11.jpg?v=9958744e846ec866398cabdf9122ac34',
    unitPrice: 13.5,
    boxQuantity: 24,
    boxPrice: 324,
    specification: '300g * 24개/박스',
    specificationZh: '300g * 24个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '냉장보관',
    storageMethodZh: '冷藏保存',
    barcode: '8809343500688',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF31b',
    code: 'No.F31',
    name: '푸른정 염장꼬시래기',
    nameZh: '福乐正莞岛盐渍红藻',
    category: '해조류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/5df1dfb5-1f2b-4c15-a30d-cf25253c52b7_12.jpg?v=016b53ca420a4d16a0deaa402d3b0351',
    unitPrice: 13.5,
    boxQuantity: 24,
    boxPrice: 324,
    specification: '300g * 24개/박스',
    specificationZh: '300g * 24个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '냉장보관',
    storageMethodZh: '冷藏保存',
    barcode: '8809343500725',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF13b',
    code: 'No.F13',
    name: '푸른정 염장톳',
    nameZh: '福乐正莞岛盐渍羊栖菜',
    category: '해조류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/6fc99ab9-d42e-4fa3-9f14-22a60b6d0831_13.jpg?v=91d1146fee90bab33217b75e79d9df6d',
    unitPrice: 13.5,
    boxQuantity: 24,
    boxPrice: 324,
    specification: '300g * 24개/박스',
    specificationZh: '300g * 24个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '냉장보관',
    storageMethodZh: '冷藏保存',
    barcode: '8809343500695',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF17',
    code: 'No.F17',
    name: '푸른정 소멸치',
    nameZh: '福乐正干小鳀鱼(炒用)',
    category: '해조류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/8fd740ae-05b3-48b6-9843-125aa74ffa26_14.jpg?v=6103611513a4b81763639191b04074f0',
    unitPrice: 35,
    boxQuantity: 18,
    boxPrice: 630,
    specification: '200g * 18개/박스',
    specificationZh: '200g * 18个/箱',
    expiryInfo: '제조일로부터 24개월',
    expiryInfoZh: '自生产日起24个月',
    storageMethod: '냉동보관',
    storageMethodZh: '冷冻保存',
    barcode: '8809343500596',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF14b',
    code: 'No.F14',
    name: '푸른정 대멸치',
    nameZh: '福乐正干大鳀鱼(炒用)',
    category: '해조류',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/57cc4bf4-8e35-4b10-9efb-310d811f44bf_15.jpg?v=c0b1c639f6f421616ffcddd30f3c89cb',
    unitPrice: 30,
    boxQuantity: 18,
    boxPrice: 540,
    specification: '200g * 18개/박스',
    specificationZh: '200g * 18个/箱',
    expiryInfo: '제조일로부터 24개월',
    expiryInfoZh: '自生产日起24个月',
    storageMethod: '냉동보관',
    storageMethodZh: '冷冻保存',
    barcode: '8809434500619',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
  },

  /* ───────── 음료·두유 ───────── */
  {
    id: 'iIR01',
    code: 'No.IR01',
    name: '황성주 건강한 검은콩두유',
    nameZh: '益人黑豆豆乳饮料',
    category: '음료·두유',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/b92e156f-463f-42a1-b640-c86dae9df007_16.jpg?v=0632a844b6c10bbda2b6dd5b5f1687b0',
    unitPrice: 50,
    boxQuantity: 16,
    boxPrice: 200,
    specification: '190ml * 16입/4박스',
    specificationZh: '190ml * 16入/4箱',
    expiryInfo: '제조일로부터 9개월',
    expiryInfoZh: '自生产日起9个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809111699514',
    tags: ['recommended', 'popular'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'iIR02',
    code: 'No.IR02',
    name: '황성주 검은콩 17곡두유',
    nameZh: '益人黑豆谷物风味豆乳饮料',
    category: '음료·두유',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/dde569a8-9731-4af9-9e65-2973e9ee7daa_17.jpg?v=ff430638ea85987e146bef7b63910680',
    unitPrice: 50,
    boxQuantity: 16,
    boxPrice: 200,
    specification: '190ml * 16입/4박스',
    specificationZh: '190ml * 16入/4箱',
    expiryInfo: '제조일로부터 9개월',
    expiryInfoZh: '自生产日起9个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809111694151',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'iIR03',
    code: 'No.IR03',
    name: '황성주 검은콩 고칼슘두유',
    nameZh: '益人黑豆坚果豆乳饮料',
    category: '음료·두유',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/acb33e14-4459-40bd-b0a4-a0a8bec6e423_18.jpg?v=4416ef215255b7de8637e7475e47f759',
    unitPrice: 50,
    boxQuantity: 16,
    boxPrice: 200,
    specification: '190ml * 16입/4박스',
    specificationZh: '190ml * 16入/4箱',
    expiryInfo: '제조일로부터 9개월',
    expiryInfoZh: '自生产日起9个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809111699903',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'iIR04',
    code: 'No.IR04',
    name: '황성주 호두아몬드두유',
    nameZh: '益人扁桃仁核桃味豆乳饮料',
    category: '음료·두유',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/ea1e18bc-9142-4d10-bc80-a6bf3a43f26b_19.jpg?v=bd116ca0d6334568bab2c0e7f467e381',
    unitPrice: 50,
    boxQuantity: 16,
    boxPrice: 200,
    specification: '190ml * 16입/4박스',
    specificationZh: '190ml * 16入/4箱',
    expiryInfo: '제조일로부터 9개월',
    expiryInfoZh: '自生产日起9个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809111694199',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'iIR05',
    code: 'No.IR05',
    name: '황성주 박사 국산콩두유 무가당',
    nameZh: '益人无糖豆乳饮料',
    category: '음료·두유',
    image: 'https://i.ibb.co/Kz99JmpL/20.jpg',
    unitPrice: 50,
    boxQuantity: 16,
    boxPrice: 200,
    specification: '190ml * 16입/4박스',
    specificationZh: '190ml * 16入/4箱',
    expiryInfo: '제조일로부터 9개월',
    expiryInfoZh: '自生产日起9个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809111697213',
    tags: ['lowest'],
    badge: '최저가',
    badgeZh: '最低价',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'iIR07',
    code: 'No.IR07',
    name: '황성주 과채습관 옐로우',
    nameZh: '益人果菜习惯苹果味饮料',
    category: '음료·두유',
    image: 'https://i.ibb.co/G37MGPYD/21.jpg',
    unitPrice: 50,
    boxQuantity: 16,
    boxPrice: 200,
    specification: '190ml * 16입/4박스',
    specificationZh: '190ml * 16入/4箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809111698623',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'iIR08',
    code: 'No.IR08',
    name: '황성주 과채습관 퍼플',
    nameZh: '益人果菜习惯葡萄味饮料',
    category: '음료·두유',
    image: 'https://i.ibb.co/yF6dYWpc/22.jpg',
    unitPrice: 50,
    boxQuantity: 16,
    boxPrice: 200,
    specification: '190ml * 16입/4박스',
    specificationZh: '190ml * 16入/4箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809111698654',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'iIR12',
    code: 'No.IR12',
    name: '황성주 과채습관 그린',
    nameZh: '益人果菜习惯青葡萄味饮料',
    category: '음료·두유',
    image: 'https://i.ibb.co/qM3GbqGz/23.jpg',
    unitPrice: 50,
    boxQuantity: 16,
    boxPrice: 200,
    specification: '190ml * 16입/4박스',
    specificationZh: '190ml * 16入/4箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809111699132',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF26',
    code: 'No.F26',
    name: '헬로아이 배도라지',
    nameZh: '福乐正哈喽小孩梨子桔梗汁饮料',
    category: '음료·두유',
    image: 'https://i.ibb.co/3YBBZqkY/30.jpg',
    unitPrice: 5,
    boxQuantity: 20,
    boxPrice: 100,
    specification: '80ml * 20개/박스',
    specificationZh: '80ml * 20个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809114980053',
    tags: ['lowest'],
    badge: '최저가',
    badgeZh: '最低价',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF27',
    code: 'No.F27',
    name: '헬로아이 달콤사과',
    nameZh: '福乐正哈喽小孩苹果汁饮料',
    category: '음료·두유',
    image: 'https://i.ibb.co/9MCGkq4/31.jpg',
    unitPrice: 5,
    boxQuantity: 20,
    boxPrice: 100,
    specification: '100ml * 20개/박스',
    specificationZh: '100ml * 20个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8890114980077',
    tags: ['lowest'],
    badge: '최저가',
    badgeZh: '最低价',
    origin: '한국산',
    originZh: '韩国产',
  },

  /* ───────── 차류 ───────── */
  {
    id: 'fF18',
    code: 'No.F18',
    name: '가보팜스 꿀유자차 580g',
    nameZh: '福乐正蜂蜜柚子茶 580g',
    category: '차류',
    image: 'https://i.ibb.co/VpPQB80F/24.jpg',
    unitPrice: 23,
    boxQuantity: 20,
    boxPrice: 460,
    specification: '580g * 20개/박스',
    specificationZh: '580g * 20个/箱',
    expiryInfo: '제조일로부터 24개월',
    expiryInfoZh: '自生产日起24个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8801770100691',
    tags: ['recommended', 'popular'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF19',
    code: 'No.F19',
    name: '가보팜스 꿀유자차 1kg',
    nameZh: '福乐正蜂蜜柚子茶 1kg',
    category: '차류',
    image: 'https://i.ibb.co/ccrP0NyP/25.jpg',
    unitPrice: 33,
    boxQuantity: 12,
    boxPrice: 396,
    specification: '1kg * 12개/박스',
    specificationZh: '1kg * 12个/箱',
    expiryInfo: '제조일로부터 24개월',
    expiryInfoZh: '自生产日起24个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8810770100783',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF20',
    code: 'No.F20',
    name: '가보팜스 꿀생강차',
    nameZh: '福乐正蜂蜜生姜茶',
    category: '차류',
    image: 'https://i.ibb.co/Zpy5fSnX/26.jpg',
    unitPrice: 42,
    boxQuantity: 12,
    boxPrice: 504,
    specification: '1kg * 12개/박스',
    specificationZh: '1kg * 12个/箱',
    expiryInfo: '제조일로부터 24개월',
    expiryInfoZh: '自生产日起24个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8801770100431',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF21',
    code: 'No.F21',
    name: '가보팜스 꿀대추차',
    nameZh: '福乐正蜂蜜大枣茶',
    category: '차류',
    image: 'https://i.ibb.co/SDv28XZV/27.jpg',
    unitPrice: 42,
    boxQuantity: 12,
    boxPrice: 504,
    specification: '1kg * 12개/박스',
    specificationZh: '1kg * 12个/箱',
    expiryInfo: '제조일로부터 24개월',
    expiryInfoZh: '自生产日起24个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8801770100370',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF52',
    code: 'No.F52',
    name: '가보팜스 꿀유자&패션후르츠',
    nameZh: '福乐正蜂蜜柚子百香果茶',
    category: '차류',
    image: 'https://i.ibb.co/jkVnT7TL/28.jpg',
    unitPrice: 38,
    boxQuantity: 12,
    boxPrice: 456,
    specification: '1kg * 12개/박스',
    specificationZh: '1kg * 12个/箱',
    expiryInfo: '제조일로부터 24개월',
    expiryInfoZh: '自生产日起24个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8801770700297',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF53',
    code: 'No.F53',
    name: '가보팜스 꿀패션후르츠',
    nameZh: '福乐正蜂蜜百香果茶',
    category: '차류',
    image: 'https://i.ibb.co/chH9cMFC/29.jpg',
    unitPrice: 38,
    boxQuantity: 12,
    boxPrice: 456,
    specification: '1kg * 12개/박스',
    specificationZh: '1kg * 12个/箱',
    expiryInfo: '제조일로부터 24개월',
    expiryInfoZh: '自生产日起24个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8801770700235',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
  },

  /* ───────── 스낵·김 ───────── */
  {
    id: 'fF69',
    code: 'No.F69',
    name: '장흥무산 김부각 오리지널',
    nameZh: '福乐正原味海苔脆饼',
    category: '스낵·김',
    image: 'https://i.ibb.co/s9qzsrS5/32.jpg',
    unitPrice: 11,
    boxQuantity: 20,
    boxPrice: 220,
    specification: '45g * 20개/박스',
    specificationZh: '45g * 20个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8802957194274',
    tags: ['recommended', 'popular'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF70',
    code: 'No.F70',
    name: '장흥무산 김부각 와사비맛',
    nameZh: '福乐正芥末味海苔脆饼',
    category: '스낵·김',
    image: 'https://i.ibb.co/sp6V3Tg8/33.jpg',
    unitPrice: 11,
    boxQuantity: 20,
    boxPrice: 220,
    specification: '45g * 20개/박스',
    specificationZh: '45g * 20个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8802957194373',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
  },
  {
    id: 'fF71',
    code: 'No.F71',
    name: '장흥무산 김부각 매콤한맛',
    nameZh: '福乐正海苔脆饼辣味',
    category: '스낵·김',
    image: 'https://i.ibb.co/WNnmBN1g/34.jpg',
    unitPrice: 11,
    boxQuantity: 20,
    boxPrice: 220,
    specification: '45g * 20개/박스',
    specificationZh: '45g * 20个/箱',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8802957194472',
    tags: ['lowest'],
    badge: '최저가',
    badgeZh: '最低价',
    origin: '한국산',
    originZh: '韩国产',
  },

  /* ───────── 스낵·견과 (HBAF 바프) ───────── */
  {
    id: 'hbHB01',
    code: 'No. 2001',
    name: '바프 땅콩&아몬드 세트',
    nameZh: '芭蜂花生仁10g+扁桃仁10g组合',
    category: '스낵·김',
    image: 'https://i.ibb.co/Tqx6RXWC/1.jpg',
    unitPrice: 29.9,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '10g*20봉',
    specificationZh: '10g*20袋',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809282110001',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: '바프(HBAF) 시그니처 땅콩과 아몬드를 소포장으로 즐길 수 있는 세트입니다. 10g 소포장으로 휴대하기 편리하며, 간식·선물용으로 인기 있는 제품입니다.',
    descriptionZh: 'HBAF标志性花生仁和扁桃仁的小包装组合套装。10g小包装携带方便，作为零食和礼品深受欢迎。',
    keyFeatures: [
      { icon: 'ri-seedling-line', titleKo: '소포장 편의성', titleZh: '小包装便利', descKo: '10g 소포장으로 언제 어디서나 간편하게 즐길 수 있음', descZh: '10g小包装，随时随地方便享用' },
      { icon: 'ri-heart-pulse-line', titleKo: '건강 견과류', titleZh: '健康坚果', descKo: '땅콩과 아몬드의 품부한 단백질과 불포화지방산', descZh: '花生和扁桃仁富含蛋白质和不饱和脂肪酸' },
      { icon: 'ri-gift-line', titleKo: '선물용 추천', titleZh: '礼品推荐', descKo: '깔끔한 패키지로 선물용으로도 인기', descZh: '简洁包装，作为礼品也很受欢迎' },
    ],
  },
  {
    id: 'hbHB02',
    code: 'No. 2002',
    name: '바프 땅콩 6봉 세트',
    nameZh: '芭蜂花生仁70g*6袋',
    category: '스낵·김',
    image: 'https://i.ibb.co/q3NZtM4S/2.jpg',
    unitPrice: 44.9,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '70g*6봉',
    specificationZh: '70g*6袋',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809282110002',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '바프(HBAF) 인기 땅콩을 70g 6봉 세트로 구성한 제품입니다. 고소하고 바삭한 땅콩의 맛을 넉넉한 용량으로 즐길 수 있으며, 가성비 좋은 세트 구성입니다.',
    descriptionZh: 'HBAF人气花生仁70g*6袋套装。可以充足享用香脆花生的美味，性价比高的套装组合。',
    keyFeatures: [
      { icon: 'ri-stack-line', titleKo: '6봉 세트 구성', titleZh: '6袋套装', descKo: '70g 6봉 세트로 넉넉하게 즐길 수 있는 구성', descZh: '70g*6袋套装，可充足享用' },
      { icon: 'ri-price-tag-3-line', titleKo: '가성비 우수', titleZh: '高性价比', descKo: '세트 구성으로 단품 대비 경제적인 가격', descZh: '套装组合比单品更经济实惠' },
      { icon: 'ri-fire-line', titleKo: '고소한 맛', titleZh: '香脆美味', descKo: '바삭하고 고소한 바프 시그니처 땅콩 맛', descZh: '香脆可口的HBAF标志性花生味道' },
    ],
  },
  {
    id: 'hbHB03',
    code: 'No. 2003',
    name: '바프 아몬드&미니땅콩 세트',
    nameZh: '经典扁桃仁+新品花生',
    category: '스낵·김',
    image: 'https://i.ibb.co/Kp1xRdXQ/3.jpg',
    unitPrice: 58.9,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '20봉(혼합)',
    specificationZh: '20袋(混合)',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809282110003',
    tags: ['recommended', 'popular'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: '바프(HBAF) 클래식 아몬드와 신제품 미니땅콩을 함께 즐길 수 있는 혼합 세트입니다. 20봉 혼합 구성으로 다양한 맛을 경험할 수 있습니다.',
    descriptionZh: 'HBAF经典扁桃仁和新品花生仁的混合套装。20袋混合组合，可体验多种口味。',
    keyFeatures: [
      { icon: 'ri-shuffle-line', titleKo: '혼합 구성', titleZh: '混合组合', descKo: '아몬드와 미니땅콩을 함께 즐기는 혼합 세트', descZh: '扁桃仁和迷你花生仁混合套装' },
      { icon: 'ri-star-line', titleKo: '신제품 포함', titleZh: '含新品', descKo: '클래식 아몬드와 신제품 미니땅콩의 조합', descZh: '经典扁桃仁与新品迷你花生仁的组合' },
      { icon: 'ri-heart-pulse-line', titleKo: '건강 갬식', titleZh: '健康零食', descKo: '단백질과 영양이 품부한 건강한 견과류 간식', descZh: '富含蛋白质和营养的健康坚果零食' },
    ],
  },
  {
    id: 'hbHB04',
    code: 'No. 2004',
    name: '바프 프로틴바 6개입',
    nameZh: '蛋白棒30g',
    category: '스낵·김',
    image: 'https://i.ibb.co/RTmgK4Bf/4.jpg',
    unitPrice: 49,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '30g*6개',
    specificationZh: '30g*6个',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809282110004',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: '바프(HBAF) 프로틴바 30g 6개입 세트입니다. 운동 후 단백질 보충이나 건강한 간식으로 즐길 수 있으며, 맛있고 영양가 높은 프로틴바입니다.',
    descriptionZh: 'HBAF蛋白棒30g*6个套装。可作为运动后蛋白质补充或健康零食享用，美味且营养丰富的蛋白棒。',
    keyFeatures: [
      { icon: 'ri-run-line', titleKo: '운동 후 보충', titleZh: '运动后补充', descKo: '운동 후 단백질 보충에 최적화된 프로틴바', descZh: '专为运动后蛋白质补充优化的蛋白棒' },
      { icon: 'ri-award-line', titleKo: '고단백 설계', titleZh: '高蛋白设计', descKo: '30g 소포장에 고단백 성분을 담은 영양 간식', descZh: '30g小包装中含有高蛋白成分的营养零食' },
      { icon: 'ri-leaf-line', titleKo: '건강한 성분', titleZh: '健康成分', descKo: '건강한 원료로 만든 맛있는 프로틴바', descZh: '用健康原料制成的美味蛋白棒' },
    ],
  },
  {
    id: 'hbHB05',
    code: 'No. 2005',
    name: '바프 팝콘 4봉 세트',
    nameZh: '爆米花80g',
    category: '스낵·김',
    image: 'https://i.ibb.co/b5hBK1b6/5.jpg',
    unitPrice: 49.9,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '80g*4봉',
    specificationZh: '80g*4袋',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809282110005',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '바프(HBAF) 팝콘 80g 4봉 세트입니다. 바삭하고 가벼운 팝콘을 넉넉한 용량으로 즐길 수 있으며, 영화 감상이나 파티 간식으로 인기 있는 제품입니다.',
    descriptionZh: 'HBAF爆米花80g*4袋套装。可充足享用香脆轻盈的爆米花，作为观影或派对零食深受欢迎。',
    keyFeatures: [
      { icon: 'ri-movie-line', titleKo: '영화 간식 추천', titleZh: '观影零食推荐', descKo: '영화 감상이나 파티에 어울리는 바삭한 팝콘', descZh: '适合观影或派对的香脆爆米花' },
      { icon: 'ri-stack-line', titleKo: '4봉 세트', titleZh: '4袋套装', descKo: '80g 4봉 세트로 넉넉하게 즐길 수 있는 구성', descZh: '80g*4袋套装，可充足享用' },
      { icon: 'ri-contrast-drop-line', titleKo: '가벼운 팝콘', titleZh: '轻盈爆米花', descKo: '가벼운 식감의 프리미엄 팝콘', descZh: '轻盈口感的优质爆米花' },
    ],
  },
  {
    id: 'hbHB06',
    code: 'No. 2006',
    name: '바프 아몬드&믹스넛 8봉 세트',
    nameZh: '经典扁桃仁+混合坚果',
    category: '스낵·김',
    image: 'https://i.ibb.co/fzg8YhqD/7.jpg',
    unitPrice: 49.9,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '8봉(혼합)',
    specificationZh: '8袋(混合)',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809282110006',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: '바프(HBAF) 클래식 아몬드와 믹스넛을 함께 즐길 수 있는 8봉 혼합 세트입니다. 다양한 견과류를 한 번에 즐길 수 있는 알찬 구성입니다.',
    descriptionZh: 'HBAF经典扁桃仁和混合坚果8袋混合套装。可一次享用多种坚果的丰富组合。',
    keyFeatures: [
      { icon: 'ri-shuffle-line', titleKo: '혼합 견과 구성', titleZh: '混合坚果组合', descKo: '아몬드와 믹스넛을 함께 즐기는 8봉 혼합 세트', descZh: '扁桃仁和混合坚果8袋混合套装' },
      { icon: 'ri-heart-pulse-line', titleKo: '영양 균형', titleZh: '营养均衡', descKo: '다양한 견과류로 균형 잡힌 영양 섭취 가능', descZh: '多种坚果均衡营养摄取' },
      { icon: 'ri-price-tag-3-line', titleKo: '가성비 세트', titleZh: '高性价比套装', descKo: '다양한 견과류를 합리적인 가격에 즐기는 세트', descZh: '以合理价格享用多种坚果的套装' },
    ],
  },
  {
    id: 'hbHB07',
    code: 'No. 2007',
    name: '바프 아몬드&믹스넛 12봉 세트',
    nameZh: '经典口味扁桃仁+混合坚果',
    category: '스낵·김',
    image: 'https://i.ibb.co/VYxztvJf/8.jpg',
    unitPrice: 71.9,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '12봉(혼합)',
    specificationZh: '12袋(混合)',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809282110007',
    tags: ['recommended', 'popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '바프(HBAF) 클래식 아몬드와 믹스넛을 12봉 대용량으로 구성한 세트입니다. B2B 대량 구매에 최적화된 넉넉한 구성으로, 선물세트로도 인기 있습니다.',
    descriptionZh: 'HBAF经典扁桃仁和混合坚果12袋大容量套装。适合B2B大量采购的充足组合，作为礼品套装也很受欢迎。',
    keyFeatures: [
      { icon: 'ri-stack-line', titleKo: '12봉 대용량', titleZh: '12袋大容量', descKo: '12봉 대용량으로 B2B 대량 구매에 최적화', descZh: '12袋大容量，最适合B2B大量采购' },
      { icon: 'ri-gift-line', titleKo: '선물세트 추천', titleZh: '礼品套装推荐', descKo: '넉넉한 구성으로 선물세트로도 인기', descZh: '充足组合，作为礼品套装也很受欢迎' },
      { icon: 'ri-building-line', titleKo: 'B2B 최적화', titleZh: 'B2B最优化', descKo: '기업·단체 대량 구매에 적합한 대용량 세트', descZh: '适合企业·团体大量采购的大容量套装' },
    ],
  },
  {
    id: 'hbHB08',
    code: 'No. 2008',
    name: '바프 클래식 아몬드 5봉 세트',
    nameZh: '经典多口味扁桃仁',
    category: '스낵·김',
    image: 'https://i.ibb.co/q4ZF7yg/9.jpg',
    unitPrice: 29.9,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '30/35g*5봉',
    specificationZh: '30/35g*5袋',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '8809282110008',
    tags: ['lowest'],
    badge: '최저가',
    badgeZh: '最低价',
    origin: '한국산',
    originZh: '韩国产',
    description: '바프(HBAF) 클래식 아몬드 다양한 맛을 5봉 세트로 즐길 수 있는 제품입니다. 30/35g 소포장으로 다양한 클래식 아몬드 맛을 경험할 수 있습니다.',
    descriptionZh: 'HBAF经典多口味扁桃仁5袋套装。30/35g小包装，可体验多种经典扁桃仁口味。',
    keyFeatures: [
      { icon: 'ri-palette-line', titleKo: '다양한 맛', titleZh: '多种口味', descKo: '클래식 아몬드의 다양한 맛을 한 세트에서 경험', descZh: '一套中体验多种经典扁桃仁口味' },
      { icon: 'ri-seedling-line', titleKo: '프리미엄 아몬드', titleZh: '优质扁桃仁', descKo: '엄선된 프리미엄 아몬드로 만든 건강 간식', descZh: '精选优质扁桃仁制成的健康零食' },
      { icon: 'ri-price-tag-3-line', titleKo: '합리적 가격', titleZh: '合理价格', descKo: '프리미엄 품질을 합리적인 가격에 즐기는 세트', descZh: '以合理价格享用优质品质的套装' },
    ],
  },

  /* ───────── 김치·반찬 ───────── */
  {
    id: 'kK01a',
    code: 'No.K01-V',
    name: '하하 맛김치 1kg (비닐)',
    nameZh: '哈哈泡菜 1kg (袋装)',
    category: '김치·반찬',
    image: 'https://i.ibb.co/HTNgNNDh/image.png',
    unitPrice: 9,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '1kg / 비닐포장',
    specificationZh: '1kg / 袋装',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '냉장보관 (0~5℃)',
    storageMethodZh: '冷藏保存 (0~5℃)',
    barcode: '',
    tags: ['recommended', 'popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '중국산',
    originZh: '中国产',
  },
  {
    id: 'kK01b',
    code: 'No.K01-C',
    name: '하하 맛김치 1kg (통)',
    nameZh: '哈哈泡菜 1kg (桶装)',
    category: '김치·반찬',
    image: 'https://i.ibb.co/CpwGmKh4/image.png',
    unitPrice: 12,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '1kg / 플라스틱통',
    specificationZh: '1kg / 桶装',
    expiryInfo: '제조일로부터 12개월',
    expiryInfoZh: '自生产日起12个月',
    storageMethod: '냉장보관 (0~5℃)',
    storageMethodZh: '冷藏保存 (0~5℃)',
    barcode: '',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '중국산',
    originZh: '中国产',
  },

  /* ───────── 스킨케어·뷰티 ───────── */
  {
    id: 'atAT01',
    code: 'No.AT01',
    name: '아토팜 수딩 젤 로션 160ml ×2개 세트',
    nameZh: 'ATOPALM 舒缓凝露乳液 160ml ×2个套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202509/903fe0d9c10e18459eb03967b9d22400.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '160ml × 2개',
    specificationZh: '160ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended', 'popular'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: '아토팜 MLE 기술이 적용된 수딩 젤 로션으로, 가볍고 산뜻한 젤 타입 제형이 피부에 빠르게 흡수되어 즉각적인 수분 공급과 진정 효과를 제공합니다. 민감하고 건조한 피부에 특히 적합하며, 자극 없이 피부 장벽을 강화해 줍니다. 아이부터 어른까지 온 가족이 함께 사용할 수 있는 순한 포뮬러입니다.',
    descriptionZh: '采用ATOPALM MLE技术的舒缓凝露乳液，轻盈清爽的凝露质地能快速被皮肤吸收，即时补水并舒缓肌肤。特别适合敏感干燥肌肤，无刺激地强化皮肤屏障。温和配方适合全家老少共同使用。',
    keyFeatures: [
      { icon: 'ri-drop-line', titleKo: '즉각 수분 공급', titleZh: '即时补水', descKo: '젤 타입 제형으로 빠른 흡수 및 즉각적인 수분 공급', descZh: '凝露质地快速吸收，即时为肌肤补充水分' },
      { icon: 'ri-shield-line', titleKo: '피부 장벽 강화', titleZh: '强化皮肤屏障', descKo: 'MLE 기술로 손상된 피부 장벽을 회복하고 보호', descZh: 'MLE技术修复并保护受损皮肤屏障' },
      { icon: 'ri-heart-line', titleKo: '민감 피부 적합', titleZh: '适合敏感肌', descKo: '저자극 성분으로 민감한 피부도 안심하고 사용 가능', descZh: '低刺激成分，敏感肌肤也可安心使用' },
    ],
  },
  {
    id: 'atAT02',
    code: 'No.AT02',
    name: '아토팜 판테놀 크림 80ml ×2개 세트',
    nameZh: 'ATOPALM 泛醇乳霜 80ml ×2个套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202601/758c4bc5820c9c6b2623b44844076d8e.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '80ml × 2개',
    specificationZh: '80ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '판테놀(비타민 B5) 성분을 고농도로 함유한 집중 보습 크림입니다. 피부 재생을 촉진하고 손상된 피부 조직을 회복시켜 주며, 건조하고 거친 피부를 부드럽고 촉촉하게 가꿔줍니다. 아토피성 피부염이나 건조증으로 고민하는 분들에게 특히 추천하는 제품입니다.',
    descriptionZh: '含有高浓度泛醇（维生素B5）的集中保湿乳霜。促进皮肤再生，修复受损皮肤组织，将干燥粗糙的肌肤调理得柔软水润。特别推荐给有特应性皮炎或干燥症困扰的人群。',
    keyFeatures: [
      { icon: 'ri-medicine-bottle-line', titleKo: '판테놀 고함량', titleZh: '高含量泛醇', descKo: '비타민 B5 고농도 함유로 피부 재생 및 회복 촉진', descZh: '高浓度维生素B5促进皮肤再生与修复' },
      { icon: 'ri-water-flash-line', titleKo: '집중 보습', titleZh: '集中保湿', descKo: '장시간 지속되는 보습막 형성으로 수분 증발 차단', descZh: '形成持久保湿膜，防止水分蒸发' },
      { icon: 'ri-leaf-line', titleKo: '피부 진정', titleZh: '舒缓肌肤', descKo: '자극받은 피부를 빠르게 진정시키고 편안하게 케어', descZh: '快速舒缓受刺激的肌肤，温和护理' },
    ],
  },
  {
    id: 'atAT03',
    code: 'No.AT03',
    name: '아토팜 MLE 크림 160ml (단지형) ×2개 세트',
    nameZh: 'ATOPALM MLE乳霜 160ml (罐装) ×2个套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202601/762b6c590127dccf3cd871bfd6c8eef7.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '160ml × 2개',
    specificationZh: '160ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended', 'popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '아토팜의 핵심 기술인 MLE(Multi-Lamellar Emulsion) 기술이 집약된 시그니처 크림입니다. 인체 피부 지질과 유사한 구조로 설계되어 피부 깊숙이 침투하여 손상된 피부 장벽을 근본적으로 회복시킵니다. 단지형 용기로 사용이 편리하며, 품수의 용량으로 온 가족이 함께 사용하기 좋습니다.',
    descriptionZh: '集ATOPALM核心技术MLE（多层乳化）于一身的标志性乳霜。采用与人体皮肤脂质结构相同的多层结构设计，深入渗透肌肤，从根本上修复受损皮肤屏障。罐装容器使用方便，大容量适合全家共用。',
    keyFeatures: [
      { icon: 'ri-flask-line', titleKo: 'MLE 핵심 기술', titleZh: 'MLE核心技术', descKo: '인체 피부 지질 구조와 동일한 다층 구조로 피부 장벽 재건', descZh: '与人体皮肤脂质结构相同的多层结构，重建皮肤屏障' },
      { icon: 'ri-focus-3-line', titleKo: '심층 침투', titleZh: '深层渗透', descKo: '피부 각질층 깊숙이 침투하여 지속적인 보습 효과 제공', descZh: '深入渗透皮肤角质层，提供持久保湿效果' },
      { icon: 'ri-award-line', titleKo: '임상 검증', titleZh: '临床验证', descKo: '피부과 전문의 임상 테스트 완료, 안전성 및 효능 검증', descZh: '皮肤科专家临床测试完成，安全性与功效经过验证' },
    ],
  },
  {
    id: 'atAT04',
    code: 'No.AT04',
    name: '아토팜 MLE 크림 160ml (튜브형) X2개 세트',
    nameZh: 'ATOPALM MLE乳霜 160ml (管装) ×2个套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202601/84229315ea41164aba043fc76cb37666.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '160ml × 2개',
    specificationZh: '160ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: 'MLE 크림의 튜브형 버전으로, 위생적이고 간편한 사용이 가능합니다. 동일한 MLE 기술로 피부 장벽을 강화하면서도 튜브 타입 특유의 편리한 휴대성과 위생적인 사용감을 제공합니다. 여행이나 외출 시에도 간편하게 사용할 수 있어 인기가 높습니다.',
    descriptionZh: 'MLE乳霜的管装版本，使用更卫生便捷。采用相同的MLE技术强化皮肤屏障，同时提供管装特有的便携性和卫生使用体验。旅行或外出时也能轻松使用，深受欢迎。',
    keyFeatures: [
      { icon: 'ri-flask-line', titleKo: 'MLE 핵심 기술', titleZh: 'MLE核心技术', descKo: '인체 피부 지질 구조와 동일한 다층 구조로 피부 장벽 재건', descZh: '与人体皮肤脂质结构相同的多层结构，重建皮肤屏障' },
      { icon: 'ri-hand-sanitizer-line', titleKo: '위생적 튜브형', titleZh: '卫生管装', descKo: '튜브 타입으로 오염 없이 위생적으로 사용 가능', descZh: '管装设计，使用卫生无污染' },
      { icon: 'ri-luggage-cart-line', titleKo: '휴대 편의성', titleZh: '便于携带', descKo: '슬림한 튜브 디자인으로 여행 및 외출 시 간편 휴대', descZh: '纤细管装设计，旅行外出携带方便' },
    ],
  },
  {
    id: 'atAT05',
    code: 'No.AT05',
    name: '아토팜 릴렉싱 나이트 밤 100ml ×2개 세트',
    nameZh: 'ATOPALM 舒缓夜间修护霜 100ml ×2个套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202510/2c23542ef25ce325a32177bb9f5c4655.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '100ml × 2개',
    specificationZh: '100ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '수면 중 피부 재생 사이클에 맞춰 설계된 나이트 케어 밤입니다. 품수의 영양 성분이 밤새 피부에 작용하여 낮 동안 받은 자극과 손상을 회복시켜 줍니다. 아침에 일어나면 한층 부드럽고 촉촉해진 피부를 경험할 수 있으며, 특히 건조하고 예민한 피부에 효과적입니다.',
    descriptionZh: '专为睡眠中皮肤再生周期设计的夜间护理霜。丰富的营养成分整夜作用于皮肤，修复白天受到的刺激和损伤。早晨醒来可感受到更加柔软水润的肌肤，对干燥敏感肌肤尤为有效。',
    keyFeatures: [
      { icon: 'ri-moon-line', titleKo: '야간 집중 케어', titleZh: '夜间集中护理', descKo: '수면 중 피부 재생 사이클에 맞춘 야간 전용 포뮬러', descZh: '专为睡眠中皮肤再生周期设计的夜间专用配方' },
      { icon: 'ri-sparkling-line', titleKo: '영양 집중 공급', titleZh: '集中营养补给', descKo: '풍부한 영양 성분으로 손상된 피부 조직 집중 회복', descZh: '丰富营养成分集中修复受损皮肤组织' },
      { icon: 'ri-sun-line', titleKo: '아침 피부 개선', titleZh: '改善晨间肌肤', descKo: '기상 후 즉각 느껴지는 부드럽고 촉촉한 피부 결', descZh: '起床后立即感受到柔软水润的肌肤质感' },
    ],
  },
  {
    id: 'atAT06',
    code: 'No.AT06',
    name: '아토팜 MLE 워터리 크림 100ml ×2개 세트',
    nameZh: 'ATOPALM MLE水润乳霜 100ml ×2个套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202509/e0fc241303776661383f0f2c2e721415.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '100ml × 2개',
    specificationZh: '100ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: 'MLE 기술에 워터리 포뮬러를 결합한 가벼운 수분 크림입니다. 끈적임 없이 산뜻하게 흡수되면서도 충분한 수분을 공급하여 지성 및 복합성 피부에도 적합합니다. 여름철이나 더운 날씨에도 가볍게 사용할 수 있으며, 메이크업 베이스로도 활용 가능합니다.',
    descriptionZh: '将MLE技术与水润配方相结合的轻盈水分乳霜。无黏腻感，清爽吸收的同时充分补水，适合油性及混合性肌肤。夏季或炎热天气也可轻盈使用，还可作为妆前乳使用。',
    keyFeatures: [
      { icon: 'ri-flask-line', titleKo: 'MLE 워터리', titleZh: 'MLE水润', descKo: 'MLE 기술과 워터리 포뮬러의 결합으로 가볍고 촉촉한 사용감', descZh: 'MLE技术与水润配方结合，轻盈水润的使用感' },
      { icon: 'ri-blur-off-line', titleKo: '산뜻한 흡수', titleZh: '清爽吸收', descKo: '끈적임 없이 빠르게 흡수되어 산뜻한 마무리감', descZh: '无黏腻感，快速吸收，清爽收尾' },
      { icon: 'ri-sun-cloudy-line', titleKo: '사계절 사용', titleZh: '四季适用', descKo: '가벼운 제형으로 계절에 관계없이 사용 가능', descZh: '轻盈质地，不受季节限制均可使用' },
    ],
  },
  {
    id: 'atAT07',
    code: 'No.AT07',
    name: '아토팜 키즈 프레쉬 페이셜 클렌저 150ml×2개 세트',
    nameZh: 'ATOPALM 儿童清爽洁面乳 150ml ×2个套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202509/b89364b1ed767d99216d4a82a7b53c16.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '150ml × 2개',
    specificationZh: '150ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '아이들의 예민한 피부를 위해 특별히 개발된 순한 페이셜 클렌저입니다. 자극적인 계면활성제를 배제하고 천연 유래 세정 성분을 사용하여 피부 자극 없이 깨끗하게 세정합니다. 눈에 들어가도 자극이 없는 저자극 포뮬러로 아이들이 안심하고 사용할 수 있습니다.',
    descriptionZh: '专为儿童敏感肌肤特别研发的温和洁面乳。排除刺激性表面活性剂，使用天然来源清洁成分，无刺激地彻底清洁。低刺激配方即使进入眼睛也无刺激，儿童可安心使用。',
    keyFeatures: [
      { icon: 'ri-user-smile-line', titleKo: '키즈 전용', titleZh: '儿童专用', descKo: '아이들의 예민한 피부를 위한 초순한 성분 구성', descZh: '专为儿童敏感肌肤特别设计的低刺激配方' },
      { icon: 'ri-eye-line', titleKo: '눈 자극 없음', titleZh: '无眼部刺激', descKo: '눈에 들어가도 자극 없는 안전한 성분 구성', descZh: '即使进入眼睛也无刺激的安全成分组合' },
      { icon: 'ri-leaf-line', titleKo: '천연 유래 성분', titleZh: '天然来源成分', descKo: '자연에서 유래한 순한 세정 성분으로 피부 보호', descZh: '来自自然的温和清洁成分，保护皮肤' },
    ],
  },
  {
    id: 'atAT08',
    code: 'No.AT08',
    name: '아토팜 페이셜 폼 워시 150ml×2개 세트',
    nameZh: 'ATOPALM 洁面泡沫 150ml ×2个套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202509/7326e44b686d78c42f94b8ba4153b818.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '150ml × 2개',
    specificationZh: '150ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩국산',
    description: '풍성하고 부드러운 거품으로 피부를 자극 없이 깨끗하게 세정하는 폼 워시입니다. 세정 후에도 당김 없이 촉촉한 피부 상태를 유지해 주며, 민감한 피부도 편안하게 사용할 수 있습니다. 아토팜의 MLE 기술이 적용되어 세정 중에도 피부 장벽을 보호합니다.',
    descriptionZh: '以丰盈柔软的泡沫无刺激地彻底清洁皮肤的泡沫洗面奶。洁面后皮肤不紧绷，保持水润状态，敏感肌肤也可舒适使用。应用ATOPALM的MLE技术，洁面过程中也能保护皮肤屏障。',
    keyFeatures: [
      { icon: 'ri-bubble-chart-line', titleKo: '풍성한 거품', titleZh: '丰盈泡沫', descKo: '부드럽고 품성한 거품이 모공 속 노폐물까지 깨끗이 제거', descZh: '柔软丰盈的泡沫彻底清除毛孔内的废物' },
      { icon: 'ri-drop-line', titleKo: '세정 후 촉촉함', titleZh: '洁面后水润', descKo: '세정 후에도 당김 없이 촉촉한 피부 상태 유지', descZh: '洁面后皮肤不紧绷，保持水润状态' },
      { icon: 'ri-shield-line', titleKo: '장벽 보호 세정', titleZh: '屏障保护洁面', descKo: 'MLE 기술로 세정 중에도 피부 장벽 손상 최소화', descZh: 'MLE技术最大限度减少洁面过程中的皮肤屏障损伤' },
    ],
  },
  {
    id: 'atAT09',
    code: 'No.AT09',
    name: '아토팜 키즈 밸런싱 모이스처 젤 로션 300ml×2개 세트',
    nameZh: 'ATOPALM 儿童均衡保湿凝露乳液 300ml ×2个套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202509/ed0d1fe7519b71f35b44a55fa1ce2edd.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '300ml × 2개',
    specificationZh: '300ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: '아이들의 피부 수분 밸런스를 균형 있게 유지해 주는 젤 타입 로션입니다. 가볍고 산뜻한 젤 제형이 피부에 빠르게 흡수되어 끈적임 없이 촉촉함을 유지해 줍니다. 대용량 300ml로 온 가족이 넉넉하게 사용할 수 있으며, 아이들의 활동적인 일상에 맞게 빠른 흡수력을 자랑합니다.',
    descriptionZh: '均衡维持儿童皮肤水分平衡的凝露型乳液。轻盈清爽的凝露质地快速被皮肤吸收，无黏腻感地保持水润。大容量300ml全家可充裕使用，快速吸收力适合儿童活跃的日常生活。',
    keyFeatures: [
      { icon: 'ri-scales-line', titleKo: '수분 밸런싱', titleZh: '水分均衡', descKo: '피부 수분과 유분의 균형을 맞춰 건강한 피부 상태 유지', descZh: '平衡皮肤水分与油脂，维持健康肌肤状态' },
      { icon: 'ri-run-line', titleKo: '빠른 흡수', titleZh: '快速吸收', descKo: '활동적인 아이들을 위한 빠른 흡수 젤 타입 제형', descZh: '为活跃儿童设计的快速吸收凝露质地' },
      { icon: 'ri-gift-line', titleKo: '대용량 경제적', titleZh: '大容量经济实惠', descKo: '300ml 대용량으로 온 가족이 함께 사용 가능', descZh: '300ml大容量，全家可共同使用' },
    ],
  },
  {
    id: 'atAT10',
    code: 'No.AT10',
    name: '아토팜 키즈 허니 로션 300ml×2 세트',
    nameZh: 'ATOPALM 儿童蜂蜜乳液 300ml ×2套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202509/8b6e4570c857b251de02c5e3a815da6c.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '300ml × 2개',
    specificationZh: '300ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '천연 꿀 성분을 함유한 아이들을 위한 보습 로션입니다. 꿀의 천연 보습 성분이 피부에 촉촉함을 오래 유지시켜 주며, 달콤한 허니 향이 아이들의 목욕 후 케어를 더욱 즐겁게 만들어 줍니다. 부드럽고 순한 성분으로 신생아부터 사용 가능합니다.',
    descriptionZh: '含有天然蜂蜜成分的儿童保湿乳液。蜂蜜的天然保湿成分长时间保持皮肤水润，甜蜜的蜂蜜香气让孩子们的沐浴后护理更加愉快。柔和温和的成分，从新生儿起即可使用。',
    keyFeatures: [
      { icon: 'ri-seedling-line', titleKo: '천연 꿀 성분', titleZh: '天然蜂蜜成分', descKo: '천연 꿀의 보습 성분으로 피부에 오래 지속되는 촉촉함 제공', descZh: '天然蜂蜜成分同时为面部皮肤补充营养和水分' },
      { icon: 'ri-heart-pulse-line', titleKo: '아이 피부 맞춤', titleZh: '儿童肌肤定制', descKo: '아이들의 연약한 얼굴 피부를 위한 초순한 성분 구성', descZh: '为儿童娇嫩面部皮肤精选超温和成分' },
    ],
  },
  {
    id: 'atAT11',
    code: 'No.AT11',
    name: '아토팜 키즈 허니 페이스 로션 150ml X2개 세트',
    nameZh: 'ATOPALM 儿童蜂蜜面部乳液 150ml ×2个套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202509/747df996cc1ee1df6da557e12601afad.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '150ml × 2개',
    specificationZh: '150ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
    description: '아이들의 얼굴 피부를 위해 특별히 설계된 페이스 전용 허니 로션입니다. 얼굴 피부의 특성에 맞게 더욱 가볍고 산뜻한 제형으로 개발되었으며, 천연 꿀 성분이 얼굴 피부에 촉촉함과 영양을 공급합니다. 자외선 차단 성분은 포함되지 않아 자외선 차단제와 함께 사용하는 것을 권장합니다.',
    descriptionZh: '专为儿童面部皮肤特别设计的面部专用蜂蜜乳液。针对面部皮肤特性开发了更轻盈清爽的质地，天然蜂蜜成分为面部皮肤补充水分和营养。不含防晒成分，建议与防晒霜一起使用。',
    keyFeatures: [
      { icon: 'ri-emotion-happy-line', titleKo: '페이스 전용', titleZh: '面部专用', descKo: '얼굴 피부 특성에 맞게 설계된 가볍고 산뜻한 제형', descZh: '针对面部皮肤特性设计的轻盈清爽质地' },
      { icon: 'ri-seedling-line', titleKo: '허니 영양 공급', titleZh: '蜂蜜营养补给', descKo: '천연 꿀 성분으로 얼굴 피부에 영양과 수분 동시 공급', descZh: '天然蜂蜜成分同时为面部皮肤补充营养和水分' },
      { icon: 'ri-user-smile-line', titleKo: '아이 피부 맞춤', titleZh: '儿童肌肤定制', descKo: '아이들의 연약한 얼굴 피부를 위한 초순한 성분 구성', descZh: '为儿童娇嫩面部皮肤精选超温和成分' },
    ],
  },
  {
    id: 'atAT12',
    code: 'No.AT12',
    name: '[맘앤베이비] 아토팜 모이스처 바디 워시 580ml×2개 세트',
    nameZh: '[妈妈&宝贝] ATOPALM 保湿沐浴露 580ml ×2个套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202509/e9c02119a3ef87410ed023135790e73f.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '580ml × 2개',
    specificationZh: '580ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: '엄마와 아기가 함께 사용할 수 있는 맘앤베이비 라인의 보습 바디 워시입니다. 임산부와 신생아 모두에게 안전한 성분으로 구성되어 있으며, 세정 후에도 피부 수분을 유지해 주는 보습 성분이 품수에 품질이 향합니다. 자극적인 향료와 색소를 배제하여 예민한 피부도 안심하고 사용할 수 있습니다.',
    descriptionZh: '妈妈和宝宝可共同使用的妈妈&宝贝系列保湿沐浴露。由对孕妇和新生儿均安全的成分组成，富含洁面后也能维持皮肤水分的保湿成分。排除刺激性香料和色素，敏感肌肤也可安心使用。',
    keyFeatures: [
      { icon: 'ri-hand-heart-line', titleKo: '크림 오일 결합', titleZh: '乳霜油脂结合', descKo: '크림의 보습력과 오일의 영양을 동시에 제공하는 하이브리드 제형', descZh: '同时提供乳霜保湿力和油脂营养的混合质地' },
      { icon: 'ri-pulse-line', titleKo: '혈액순환 촉진', titleZh: '促进血液循环', descKo: '마사지 효과로 피부 혈액순환을 활성화하여 건康한 피부 유지', descZh: '通过按摩效果激活皮肤血液循环，维持健康肌肤' },
      { icon: 'ri-contrast-2-line', titleKo: '논스티키 마무리', titleZh: '无黏腻收尾', descKo: '사용 후 끈적임 없이 부드럽고 촉촉한 피부 마무리', descZh: '使用后无黏腻感，柔软水润的肌肤收尾' },
    ],
  },
  {
    id: 'atAT13',
    code: 'No.AT13',
    name: '[맘앤베이비] 아토팜 스칼프 모이스처 샴푸 580ml×2개 세트',
    nameZh: '[妈妈&宝贝] ATOPALM 头皮保湿洗发水 580ml ×2个套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202509/43e7cbb14bb493112c779676ddbdc49d.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '580ml × 2개',
    specificationZh: '580ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
    description: '두피와 모발에 수분을 공급하는 맘앤베이비 라인의 샴푸입니다. 임산부의 예민해진 두피와 아기의 연약한 두피 모두에 적합하도록 설계되었습니다. 자극 없이 두피를 청결하게 유지하면서 모발에 윤기와 부드러움을 더해줍니다. 실리콘 프리 포뮬러로 두피 건康을 지킵니다.',
    descriptionZh: '为头皮和发丝补充水分的妈妈&宝贝系列洗发水。专为孕妇敏感头皮和婴儿娇嫩头皮设计。无刺激地保持头皮清洁，同时为发丝增添光泽和柔顺感。无硅油配方守护头皮健康。',
    keyFeatures: [
      { icon: 'ri-medicine-bottle-line', titleKo: '수분 공급', titleZh: '水分补充', descKo: '두피와 모발에 수분을 공급하는 집중 보습', descZh: '为头皮和发丝补充水分的集中保湿' },
      { icon: 'ri-pulse-line', titleKo: '두피 청결', titleZh: '头皮清洁', descKo: '자극 없는 두피 청결 유지 및 진정', descZh: '无刺激保持头皮清洁并舒缓' },
      { icon: 'ri-leaf-line', titleKo: '윤기 부드러움', titleZh: '光泽柔顺', descKo: '두피와 모발에 윤기와 부드러움을 더해주는 성분', descZh: '为头皮和发丝增添光泽和柔顺感的成分' },
    ],
  },
  {
    id: 'atAT15',
    code: 'No.AT15',
    name: '아토팜 매터니티 케어 스칼프 테라피 샴푸 460mlx2개 세트',
    nameZh: 'ATOPALM 孕妇头皮护理洗发水 460ml ×2个套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202509/efa4391a905736464f28267303ca02b8.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '460ml × 2개',
    specificationZh: '460ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
    description: '임산부의 호르몬 변화로 인한 두피 트러블과 탈모 고민을 케어하는 전문 샴푸입니다. 임신 중 예민해진 두피를 진정시키고 모발에 영양을 공급하여 건康한 두피 환경을 만들어 줍니다. 임산부에게 안전한 성분만을 사용하여 태아에게도 안심할 수 있습니다.',
    descriptionZh: '专门护理因孕期激素变化引起的头皮问题和脱发烦恼的专业洗发水。舒缓孕期敏感头皮，为发丝补充营养，营造健康头皮环境。仅使用对孕妇安全的成分，对胎儿也可放心。',
    keyFeatures: [
      { icon: 'ri-women-line', titleKo: '임산부 전용', titleZh: '孕妇专用', descKo: '임신 중 호르몬 변화로 인한 두피 트러블 전문 케어', descZh: '专业护理孕期头皮问题' },
      { icon: 'ri-seedling-line', titleKo: '탈모 케어', titleZh: '脱发护理', descKo: '임신 중 탈모 고민을 완화하는 두피 강화 성분 함유', descZh: '含有缓解孕期脱发烦恼的头皮强化成分' },
      { icon: 'ri-shield-check-line', titleKo: '태아 안전 성분', titleZh: '胎儿安全成分', descKo: '임산부와 태아 모두에게 안전한 성분만 사용', descZh: '仅使用对孕妇和胎儿均安全的成分' },
    ],
  },
  {
    id: 'atAT16',
    code: 'No.AT16',
    name: '아토팜 키즈 워터 겔 미스트 100g',
    nameZh: 'ATOPALM 儿童水润凝露喷雾 100g',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202406/3b4c32c9d9c876699b382044db0cf29c.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '100g',
    specificationZh: '100g',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
    description: '언제 어디서나 간편하게 사용할 수 있는 아이들을 위한 미스트 타입 수분 보충제입니다. 미세한 입자로 분사되어 피부에 고르게 흡수되며, 즉각적인 수분 공급과 진정 효과를 제공합니다. 외출 시나 야외 활동 후 피부가 건조해졌을 때 간편하게 사용할 수 있어 실용적입니다.',
    descriptionZh: '随时随地可方便使用的儿童专用喷雾型水分补充剂。以细微粒子喷出，均匀被皮肤吸收，提供即时补水和舒缓效果。外出时或户外活动后皮肤干燥时可方便使用，非常实用。',
    keyFeatures: [
      { icon: 'ri-contrast-drop-line', titleKo: '미스트 타입', titleZh: '喷雾类型', descKo: '미세 입자 분사로 피부에 고르고 빠르게 흡수', descZh: '细微粒子喷出，均匀快速被皮肤吸收' },
      { icon: 'ri-map-pin-line', titleKo: '휴대 간편', titleZh: '携带方便', descKo: '소형 용기로 가방에 넣어 언제 어디서나 간편 사용', descZh: '小型容器放入包中，随时随地方便使用' },
      { icon: 'ri-flashlight-line', titleKo: '즉각 진정', titleZh: '即时舒缓', descKo: '외출 후 자극받은 피부를 즉각적으로 진정시켜 주는 효과', descZh: '使用后无黏腻感，柔软水润的肌肤收尾' },
    ],
  },
  {
    id: 'atAT17',
    code: 'No.AT17',
    name: '[맘앤베이비] 아토팜 모이스처 멀티 오일 250ml',
    nameZh: '[妈妈&宝贝] ATOPALM 保湿多效护肤油 250ml',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202507/4017af4523c7de1279664966a655a366.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '250ml',
    specificationZh: '250ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
    description: '엄마와 아기 모두에게 사용 가능한 다목적 보습 오일입니다. 얼굴, 바디, 두피 등 전신에 사용 가능하며, 임산부의 튼살 예방에도 효과적입니다. 천연 식물성 오일 성분이 피부에 깊이 침투하여 영양을 공급하고 피부 탄력을 높여줍니다. 가볍고 산뜻한 오일 타입으로 끈적임 없이 사용 가능합니다.',
    descriptionZh: '妈妈和宝宝均可使用的多功能保湿油。可用于面部、身体、头皮等全身，对预防孕妇妊娠纹也有效。天然植物性油脂成分深入渗透皮肤，补充营养并提升皮肤弹性。轻盈清爽的油脂类型，无黏腻感可使用。',
    keyFeatures: [
      { icon: 'ri-apps-line', titleKo: '멀티 사용', titleZh: '多效使用', descKo: '얼굴·바디·두피 전신에 사용 가능한 올인원 오일', descZh: '可用于面部·身体·头皮全身的多合一护肤油' },
      { icon: 'ri-shield-star-line', titleKo: '피부 보호막 강화', titleZh: '强化皮肤保护膜', descKo: '신생아 피부의 자연 보호막을 강화하여 외부 자극 차단', descZh: '强化新生儿皮肤天然保护膜，阻隔外部刺激' },
      { icon: 'ri-stethoscope-line', titleKo: '피부과 테스트', titleZh: '皮肤科测试', descKo: '피부과 전문의 임상 테스트 완료, 안전성 및 효능 검증', descZh: '皮肤科专家临床测试，安全性验证完成' },
    ],
  },
  {
    id: 'atAT18',
    code: 'No.AT18',
    name: '아토팜 마일드 샴푸 300ml ×2개 세트',
    nameZh: 'ATOPALM 温和洗发水 300ml ×2个套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202509/d9bd3231ac8fecf0220afa4e885a63e6.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '300ml × 2개',
    specificationZh: '300ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
    description: '아이들의 두피와 모발을 순하게 케어하는 마일드 샴푸입니다. 자극적인 계면활성제를 배제하고 천연 유래 세정 성분을 사용하여 두피 자극 없이 깨끗하게 세정합니다. 세정 후에도 두피와 모발에 수분을 유지하여 건康하고 윤기 있는 모발을 만들어 줍니다.',
    descriptionZh: '温和护理儿童头皮和发丝的温和洗发水。排除刺激性表面活性剂，使用天然来源清洁成分，无头皮刺激地彻底清洁。洁发后也能维持头皮和发丝水分，打造健康有光泽的发丝。',
    keyFeatures: [
      { icon: 'ri-leaf-line', titleKo: '천연 세정 성분', titleZh: '天然清洁成分', descKo: '자연 유래 성분으로 두피 자극 없이 순하게 세정', descZh: '天然来源成分，无头皮刺激温和清洁' },
      { icon: 'ri-water-percent-line', titleKo: '두피·모발 보습', titleZh: '头皮发丝保湿', descKo: '세정 후에도 두피와 모발의 수분을 유지하는 보습 성분', descZh: '洁发后也能维持头皮和发丝水分的保湿成分' },
      { icon: 'ri-user-smile-line', titleKo: '아이 두피 맞춤', titleZh: '儿童头皮定制', descKo: '아이들의 연약한 두피를 위한 초저자극 포뮬러', descZh: '为儿童娇嫩头皮设计的超低刺激配方' },
    ],
  },
  {
    id: 'atAT19',
    code: 'No.AT19',
    name: '아토팜 탑투토 워시 460mlX2개 세트',
    nameZh: 'ATOPALM 全身沐浴露 460ml ×2个套装',
    category: '스킨케어·뷰티',
    image: 'https://neopharmshop.co.kr/web/product/medium/202509/ca47297d1672e62ade24f7297cc1980f.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '460ml × 2개',
    specificationZh: '460ml × 2个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '머리부터 발끝까지 전신을 하나로 케어하는 올인원 워시입니다. 샴푸와 바디 워시를 하나로 합쳐 목욕 시간을 간편하게 만들어 주며, 아이들의 전신 피부와 두피를 동시에 순하게 케어합니다. 품성한 거품과 순한 세정력으로 아이들의 목욕 시간을 즐겁게 만들어 줍니다.',
    descriptionZh: '从头到脚全身一次护理的多合一沐浴露。将洗发水和沐浴露合二为一，简化沐浴时间，同时温和护理儿童全身皮肤和头皮。丰盈泡沫和温和清洁力让孩子们的沐浴时间更加愉快。',
    keyFeatures: [
      { icon: 'ri-body-scan-line', titleKo: '탑투토 올인원', titleZh: '全身多合一', descKo: '머리부터 발끝까지 전신을 하나의 제품으로 케어', descZh: '从头到脚全身用一款产品护理' },
      { icon: 'ri-bubble-chart-line', titleKo: '풍성한 거품', titleZh: '丰盈泡沫', descKo: '풍성하고 부드러운 거품으로 즐거운 목욕 시간 제공', descZh: '丰盈柔软的泡沫提供愉快的沐浴时间' },
      { icon: 'ri-time-line', titleKo: '목욕 시간 단축', titleZh: '缩短沐浴时间', descKo: '샴푸+바디워시 일체형으로 목욕 시간을 효율적으로 단축', descZh: '洗发水+沐浴露一体型，高效缩短沐浴时间' },
    ],
  },

  /* ───────── 섬유향수 (드레스룸) ───────── */
  {
    id: 'drDR01',
    code: 'No.DR01',
    name: '드레스룸 섬유향수 No.20 플라워샵 70ml',
    nameZh: 'W.DRESSROOM 衣物香水 No.20 花店 70ml',
    category: '섬유향수',
    image: 'https://wdressroom.co.kr/web/product/medium/202309/ecd4d5a5044910e2223256cbea506d90.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    consumerPrice: 49,
    onlinePrice: 39,
    livePrice1: 29,
    livePrice3: 79,
    specification: '70ml',
    specificationZh: '70ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '드레스룸 시그니처 섬유향수 No.20 프루티플로럴. 상큼한 과일향과 화사한 플로럴이 조화를 이루는 향으로, 옷감에 뿌리면 은은하게 오래 지속됩니다. 의류, 침구, 커튼 등 다양한 섬유에 사용 가능합니다.',
    descriptionZh: 'W.DRESSROOM标志性衣物香水No.20果香花香。清新果香与明媚花香和谐融合，喷洒在衣物上香气持久淡雅。可用于服装、床品、窗帘等各种织物。',
    keyFeatures: [
      { icon: 'ri-flower-line', titleKo: '프루티플로럴 향', titleZh: '果香花香', descKo: '상큼한 과일향과 화사한 플로럴의 조화로운 블렌딩', descZh: '清新果香与明媚花香的和谐融合' },
      { icon: 'ri-time-line', titleKo: '지속력 우수', titleZh: '持久留香', descKo: '섬유에 오래 지속되는 향으로 하루 종일 상쾌함 유지', descZh: '香气在织物上持久留存，全天保持清爽' },
      { icon: 'ri-shirt-line', titleKo: '다용도 사용', titleZh: '多用途使用', descKo: '의류·침구·커튼 등 모든 섬유 제품에 사용 가능', descZh: '可用于服装·床品·窗帘等所有织物产品' },
    ],
  },
  {
    id: 'drDR02',
    code: 'No.DR02',
    name: '드레스룸 섬유향수 No.11 화이트솝 70ml',
    nameZh: 'W.DRESSROOM 衣物香水 No.11 白皂香 70ml',
    category: '섬유향수',
    image: 'https://wdressroom.co.kr/web/product/medium/202309/8bb129f3ff161d2d873cea7eb7bd24d6.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    consumerPrice: 49,
    onlinePrice: 39,
    livePrice1: 29,
    livePrice3: 79,
    specification: '70ml',
    specificationZh: '70ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩국산',
    description: '드레스룸 섬유향수 No.21 화이트머스크. 깨끗하고 포근한 화이트머스크 향이 섬유에 스며들어 세탁 후 갓 꺼낸 듯한 청결한 느낌을 줍니다. 남녀노소 누구나 좋아하는 무난하고 세련된 향입니다.',
    descriptionZh: 'W.DRESSROOM衣物香水No.21白麝香。洁净温暖的白麝香渗入织物，带来刚洗完衣物般的清洁感。男女老少皆宜的百搭优雅香气。',
    keyFeatures: [
      { icon: 'ri-sparkling-line', titleKo: '화이트머스크', titleZh: '白麝香', descKo: '깨끗하고 포근한 화이트머스크의 세련된 향기', descZh: '洁净温暖的白麝香优雅香气' },
      { icon: 'ri-user-heart-line', titleKo: '남녀 공용', titleZh: '男女通用', descKo: '남녀노소 누구나 좋아하는 무난하고 편안한 향', descZh: '男女老少皆宜的百搭舒适香气' },
      { icon: 'ri-leaf-line', titleKo: '천연 유래 성분', titleZh: '天然来源成分', descKo: '자연에서 유래한 순한 세정 성분으로 피부 보호', descZh: '来自自然的温和清洁成分，保护皮肤' },
    ],
  },
  {
    id: 'drDR03',
    code: 'No.DR03',
    name: '드레스룸 섬유향수 No.10 옥토버우디 70ml',
    nameZh: 'W.DRESSROOM 衣物香水 No.10 十月木香 70ml',
    category: '섬유향수',
    image: 'https://wdressroom.co.kr/web/product/medium/202405/48d85ec7f778b2ac30a5030e99399861.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    consumerPrice: 49,
    onlinePrice: 39,
    livePrice1: 29,
    livePrice3: 79,
    specification: '70ml',
    specificationZh: '70ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '드레스룸 섬유향수 No.22 로즈부케. 싱그러운 장미꽃 향기가 섬유에 은은하게 퍼져 우아하고 로맨틱한 분위기를 연출합니다. 특별한 날 입는 옷이나 침구에 뿌려 특별한 향기를 더해보세요.',
    descriptionZh: 'W.DRESSROOM衣物香水No.22玫瑰花束。清新玫瑰花香淡雅地弥漫在织物上，营造优雅浪漫的氛围。喷洒在特别场合的服装或床品上，增添独特香气。',
    keyFeatures: [
      { icon: 'ri-flower-line', titleKo: '로즈부케 향', titleZh: '玫瑰花束香', descKo: '싱그러운 장미꽃 향기의 로맨틱한 블렌딩', descZh: '清新优雅的玫瑰花香浪漫融合' },
      { icon: 'ri-heart-line', titleKo: '로맨틱 무드', titleZh: '浪漫氛围', descKo: '특별한 날을 위한 우아하고 로맨틱한 향기 연출', descZh: '为特别日子营造优雅浪漫的香气' },
      { icon: 'ri-time-line', titleKo: '은은한 지속', titleZh: '淡雅持久', descKo: '강하지 않고 은은하게 오래 지속되는 향', descZh: '不浓烈，淡雅持久的香气' },
    ],
  },
  {
    id: 'drDR04',
    code: 'No.DR04',
    name: '드레스룸 섬유향수 No.34 올웨이즈해피 70ml',
    nameZh: 'W.DRESSROOM 衣物香水 No.34 永远快乐 70ml',
    category: '섬유향수',
    image: 'https://wdressroom.co.kr/web/product/medium/202405/3b145231d824c96a90e51439323be8bf.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    consumerPrice: 49,
    onlinePrice: 39,
    livePrice1: 29,
    livePrice3: 79,
    specification: '70ml',
    specificationZh: '70ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
    description: '드레스룸 섬유향수 No.23 코튼클라우드. 솜사탕처럼 포근하고 부드러운 코튼 향이 섬유에 스며들어 편안하고 아늑한 분위기를 연출합니다. 아이들 옷이나 침구에도 안심하고 사용할 수 있는 순한 향입니다.',
    descriptionZh: 'W.DRESSROOM衣物香水No.23棉花云。如棉花糖般温暖柔软的棉花香渗入织物，带来舒适温馨的感觉。儿童服装或床品也可安心使用的温和香气。',
    keyFeatures: [
      { icon: 'ri-cloud-line', titleKo: '코튼클라우드 향', titleZh: '棉花云香', descKo: '솜사탕처럼 포근하고 부드러운 코튼 향', descZh: '如棉花糖般温暖柔软的棉花香' },
      { icon: 'ri-heart-pulse-line', titleKo: '아이 옷 사용 가능', titleZh: '儿童衣物可用', descKo: '순한 성분으로 아이들 옷과 침구에도 안심 사용', descZh: '温和成分，儿童服装和床品也可安心使用' },
      { icon: 'ri-home-heart-line', titleKo: '아늑한 분위기', titleZh: '温馨氛围', descKo: '집에서 편안하고 아늑한 분위기를 연출하는 향', descZh: '在家营造舒适温馨氛围的香气' },
    ],
  },
  {
    id: 'drDR05',
    code: 'No.DR05',
    name: '드레스룸 섬유향수 No.38 탠저린팜 70ml',
    nameZh: 'W.DRESSROOM 衣物香水 No.38 橘子农场 70ml',
    category: '섬유향수',
    image: 'https://wdressroom.co.kr/web/product/medium/202309/acab615a8c568e4ff284d518845c3357.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    consumerPrice: 49,
    onlinePrice: 39,
    livePrice1: 29,
    livePrice3: 79,
    specification: '70ml',
    specificationZh: '70ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
    description: '드레스룸 퍼퓸 No.11 페어리우드 100ml. 화사하고 싱그러운 모란꽃 향기가 섬유에 은은하게 퍼져 봄날처럼 화사한 분위기를 연출합니다. 봄·여름 시즌에 특히 잘 어울리는 플로럴 퍼퓸입니다.',
    descriptionZh: 'W.DRESSROOM香水No.11仙境木香100ml。明媚清新的牡丹花香淡雅地弥漫在织物上，营造如春日般明媚的氛围。特别适合春夏季节的花香。',
    keyFeatures: [
      { icon: 'ri-tree-line', titleKo: '페어리우드 향', titleZh: '仙境木香', descKo: '신비롭고 따뜻한 우드 향의 자연스러운 편안함', descZh: '神秘温暖的木香自然舒适感' },
      { icon: 'ri-apps-line', titleKo: '다목적 퍼퓸', titleZh: '多功能香水', descKo: '의류·공간·침구 등 다양하게 활용 가능한 퍼퓸', descZh: '可用于服装·空间·床品等多种用途的香水' },
      { icon: 'ri-gift-line', titleKo: '선물용 추천', titleZh: '礼品推荐', descKo: '세련된 패키지로 선물용으로도 인기 있는 제품', descZh: '精致包装，作为礼品也很受欢迎的产品' },
    ],
  },
  {
    id: 'drDR06',
    code: 'No.DR06',
    name: '드레스퍼퓸 섬유향수 No.40 시크앤버 70ml',
    nameZh: 'W.DRESSROOM 衣物香水 No.40 时髦琥珀 70ml',
    category: '섬유향수',
    image: 'https://wdressroom.co.kr/web/product/medium/202405/0699d6fc7fcc9babaea4f0b8c2e21ea3.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    consumerPrice: 49,
    onlinePrice: 39,
    livePrice1: 29,
    livePrice3: 79,
    specification: '70ml',
    specificationZh: '70ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
    description: '드레스룸 퍼퓸 No.11 페어리우드 100ml. 화사하고 싱그러운 모란꽃 향기를 퍼퓸 타입으로 즐길 수 있습니다. 의류에 직접 뿌리거나 공간 향수로도 활용 가능합니다.',
    descriptionZh: 'W.DRESSROOM香水No.11仙境木香100ml。以香水类型享受明媚清新的花香。可直接喷洒在服装上，也可作为空间香水使用。',
    keyFeatures: [
      { icon: 'ri-flower-line', titleKo: '피오니 플로럴', titleZh: '牡丹花香', descKo: '화사하고 싱그러운 모란꽃의 봄날 같은 향기', descZh: '明媚清新的牡丹花春日般香气' },
      { icon: 'ri-sun-line', titleKo: '봄·여름 추천', titleZh: '春夏推荐', descKo: '봄·여름 시즌에 특히 잘 어울리는 플로럴 향', descZh: '特别适合春夏季节的花香' },
      { icon: 'ri-women-line', titleKo: '여성 의류 추천', titleZh: '女士服装推荐', descKo: '여성스럽고 화사한 분위기를 연출하는 향', descZh: '营造女性明媚氛围的香气' },
    ],
  },
  {
    id: 'drDR07',
    code: 'No.DR07',
    name: '드레스퍼퓸 섬유향수 No.49 피치블러썸 70ml',
    nameZh: 'W.DRESSROOM 衣物香水 No.49 桃花盛开 70ml',
    category: '섬유향수',
    image: 'https://wdressroom.co.kr/web/product/medium/202309/cb541ae487b91391a8a2119a7bcb2726.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    consumerPrice: 49,
    onlinePrice: 39,
    livePrice1: 29,
    livePrice3: 79,
    specification: '70ml',
    specificationZh: '70ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
    description: '드레스룸 퍼퓸 No.29 블루밍데이 100ml. 화사하고 싱그러운 플로럴 향을 퍼퓸 타입으로 즐길 수 있습니다. 의류에 직접 뿌리거나 공간 향수로도 활용 가능합니다.',
    descriptionZh: 'W.DRESSROOM香水No.29花开之日100ml。以香水类型享受明媚清新的花香。可直接喷洒在服装上，也可作为空间香水使用。',
    keyFeatures: [
      { icon: 'ri-flower-line', titleKo: '블루밍데이 향', titleZh: '花开之日香', descKo: '봄날 꽃이 만개한 듯한 화사하고 생동감 넘치는 향', descZh: '如春日百花盛开般明媚生动的香气' },
      { icon: 'ri-sun-line', titleKo: '봄·여름 추천', titleZh: '春夏推荐', descKo: '봄·여름 시즌에 특히 잘 어울리는 플로럴 향', descZh: '特别适合春夏季节的花香' },
      { icon: 'ri-apps-line', titleKo: '다목적 퍼퓸', titleZh: '多功能香水', descKo: '의류·공간·침구 등 다양하게 활용 가능한 퍼퓸', descZh: '可用于服装·空间·床品等多种用途的香水' },
    ],
  },
  {
    id: 'drDR08',
    code: 'No.DR08',
    name: '드레스퍼퓸 섬유향수 No.97 에이프릴코튼 70ml',
    nameZh: 'W.DRESSROOM 衣物香水 No.97 四月棉花 70ml',
    category: '섬유향수',
    image: 'https://wdressroom.co.kr/web/product/medium/202309/dbfc48bed683a06d7570012bb4f14276.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    consumerPrice: 49,
    onlinePrice: 39,
    livePrice1: 29,
    livePrice3: 79,
    specification: '70ml',
    specificationZh: '70ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: [],
    origin: '한국산',
    originZh: '韩国产',
    description: '드레스룸 퍼퓸 No.28 블루밍데이 100ml. 화사하고 싱그러운 플로럴 향을 퍼퓸 타입으로 즐길 수 있습니다. 의류에 직접 뿌리거나 공간 향수로도 활용 가능합니다.',
    descriptionZh: 'W.DRESSROOM香水No.28花开之日100ml。以香水类型享受明媚清新的花香。可直接喷洒在服装上，也可作为空间香水使用。',
    keyFeatures: [
      { icon: 'ri-flower-line', titleKo: '블루밍데이 향', titleZh: '花开之日香', descKo: '봄날 꽃이 만개한 듯한 화사하고 생동감 넘치는 향', descZh: '如春日百花盛开般明媚生动的香气' },
      { icon: 'ri-sun-line', titleKo: '봄·여름 추천', titleZh: '春夏推荐', descKo: '봄·여름 시즌에 특히 잘 어울리는 플로럴 향', descZh: '特别适合春夏季节的花香' },
      { icon: 'ri-apps-line', titleKo: '다목적 퍼퓸', titleZh: '多功能香水', descKo: '의류·공간·침구 등 다양하게 활용 가능한 퍼퓸', descZh: '可用于服装·空间·床品等多种用途的香水' },
    ],
  },

  /* ───────── 핸드크림 (드레스룸) ───────── */
  {
    id: 'drHC49',
    code: 'No.HC49',
    name: '드레스룸 핸드크림 No.49 복숭아 벚꽃 (피치 블라썸) 30ml',
    nameZh: 'W.DRESSROOM 护手霜 No.49 桃花盛开 (Peach Blossom) 30ml',
    category: '핸드크림',
    image: 'https://wdressroom.co.kr/web/product/big/202202/90b10e0170d992bfb5f05408563ff6fe.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    hcRetailPrice: 55,
    hcLivePrice1: 29,
    hcLivePrice3: 79,
    hcCommission: 25,
    specification: '30ml',
    specificationZh: '30ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended', 'popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '드레스룸 핸드크림 No.49 피치 블라썸. 달콤하고 싱그러운 복숭아와 벚꽃의 향기가 어우러진 핸드크림입니다. 촉촉하고 가벼운 제형으로 빠르게 흡수되며, 손을 부드럽고 촉촉하게 가꿔줍니다.',
    descriptionZh: 'W.DRESSROOM护手霜No.49桃花盛开。甜蜜清新的桃子与樱花香气融合的护手霜。轻盈水润的质地快速吸收，让双手柔软水润。',
    keyFeatures: [
      { icon: 'ri-flower-line', titleKo: '피치 블라썸 향', titleZh: '桃花盛开香', descKo: '달콤한 복숭아와 싱그러운 벚꽃의 조화로운 향기', descZh: '甜蜜桃子与清新樱花的和谐香气' },
      { icon: 'ri-drop-line', titleKo: '빠른 흡수', titleZh: '快速吸收', descKo: '가볍고 촉촉한 제형으로 끈적임 없이 빠르게 흡수', descZh: '轻盈水润质地，无黏腻感快速吸收' },
      { icon: 'ri-hand-heart-line', titleKo: '손 보습 케어', titleZh: '手部保湿护理', descKo: '건조한 손을 부드럽고 촉촉하게 가꿔주는 집중 보습', descZh: '集中保湿，让干燥双手变得柔软水润' },
    ],
  },
  {
    id: 'drHC97',
    code: 'No.HC97',
    name: '드레스룸 핸드크림 No.97 4월의 목화 (에이프릴 코튼) 30ml',
    nameZh: 'W.DRESSROOM 护手霜 No.97 四月棉花 (April Cotton) 30ml',
    category: '핸드크림',
    image: 'https://wdressroom.co.kr/web/product/big/202303/1eeb83d1a729d6f38f30fa79be7c9522.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    hcRetailPrice: 55,
    hcLivePrice1: 29,
    hcLivePrice3: 79,
    hcCommission: 25,
    specification: '30ml',
    specificationZh: '30ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: '드레스룸 핸드크림 No.97 에이프릴 코튼. 4월의 포근한 목화솜처럼 부드럽고 따뜻한 향기의 핸드크림입니다. 코튼 특유의 깨끗하고 포근한 향이 손에 은은하게 남아 하루 종일 기분 좋은 향기를 선사합니다.',
    descriptionZh: 'W.DRESSROOM护手霜No.97四月棉花。如四月温暖棉花般柔软温馨香气的护手霜。棉花特有的洁净温暖香气淡雅留存于手上，全天带来愉悦香气。',
    keyFeatures: [
      { icon: 'ri-cloud-line', titleKo: '에이프릴 코튼 향', titleZh: '四月棉花香', descKo: '4월의 포근한 목화솜처럼 부드럽고 따뜻한 향기', descZh: '如四月温暖棉花般柔软温馨的香气' },
      { icon: 'ri-drop-line', titleKo: '빠른 흡수', titleZh: '快速吸收', descKo: '가볍고 촉촉한 제형으로 끈적임 없이 빠르게 흡수', descZh: '轻盈水润质地，无黏腻感快速吸收' },
      { icon: 'ri-hand-heart-line', titleKo: '손 보습 케어', titleZh: '手部保湿护理', descKo: '건조한 손을 부드럽고 촉촉하게 가꿔주는 집중 보습', descZh: '集中保湿，让干燥双手变得柔软水润' },
    ],
  },
  {
    id: 'drHC98',
    code: 'No.HC98',
    name: '드레스룸 핸드크림 No.98 신비로운 향기 (시크릿 머스크) 30ml',
    nameZh: 'W.DRESSROOM 护手霜 No.98 神秘香气 (Secret Musk) 30ml',
    category: '핸드크림',
    image: 'https://wdressroom.co.kr/web/product/big/202202/bcb9ed470f63cf32b82d049f517d8b35.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    hcRetailPrice: 55,
    hcLivePrice1: 29,
    hcLivePrice3: 79,
    hcCommission: 25,
    specification: '30ml',
    specificationZh: '30ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '드레스룸 핸드크림 No.98 시크릿 머스크. 신비롭고 관능적인 머스크 향이 피부에 은은하게 스며드는 핸드크림입니다. 깊고 세련된 향기가 오래 지속되어 특별한 날에도 어울리는 고급스러운 핸드크림입니다.',
    descriptionZh: 'W.DRESSROOM护手霜No.98神秘香气。神秘性感的麝香淡雅渗入皮肤的护手霜。深邃优雅的香气持久留存，适合特别场合的高级护手霜。',
    keyFeatures: [
      { icon: 'ri-sparkling-line', titleKo: '시크릿 머스크 향', titleZh: '神秘麝香', descKo: '신비롭고 관능적인 머스크의 깊고 세련된 향기', descZh: '神秘性感的麝香深邃优雅香气' },
      { icon: 'ri-time-line', titleKo: '지속력 우수', titleZh: '持久留香', descKo: '피부에 오래 지속되는 향으로 하루 종일 향기 유지', descZh: '香气在皮肤上持久留存，全天保持香气' },
      { icon: 'ri-hand-heart-line', titleKo: '손 보습 케어', titleZh: '手部保湿护理', descKo: '건조한 손을 부드럽고 촉촉하게 가꿔주는 집중 보습', descZh: '集中保湿，让干燥双手变得柔软水润' },
    ],
  },
  {
    id: 'drHC11',
    code: 'No.HC11',
    name: '드레스룸 핸드크림 No.11 하얀 비누 향 (화이트 솝) 30ml',
    nameZh: 'W.DRESSROOM 护手霜 No.11 白皂香 (White Soap) 30ml',
    category: '핸드크림',
    image: 'https://wdressroom.co.kr/web/product/medium/202202/9400b9bf5e92d16724e43c87fe1e8b5d.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    hcRetailPrice: 55,
    hcLivePrice1: 29,
    hcLivePrice3: 79,
    hcCommission: 25,
    specification: '30ml',
    specificationZh: '30ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: '드레스룸 핸드크림 No.11 화이트 솝. 갓 세탁한 듯 깨끗하고 상쾌한 하얀 비누 향의 핸드크림입니다. 남녀노소 누구나 좋아하는 무난하고 세련된 향으로, 일상에서 편안하게 사용할 수 있는 베스트셀러 향입니다.',
    descriptionZh: 'W.DRESSROOM护手霜No.11白皂香。如刚洗完衣物般洁净清爽的白皂香护手霜。男女老少皆宜的百搭优雅香气，日常使用舒适的畅销香型。',
    keyFeatures: [
      { icon: 'ri-bubble-chart-line', titleKo: '화이트 솝 향', titleZh: '白皂香', descKo: '깨끗하고 상쾌한 하얀 비누의 청결한 향기', descZh: '洁净清爽的白皂清洁香气' },
      { icon: 'ri-user-heart-line', titleKo: '남녀 공용', titleZh: '男女通用', descKo: '남녀노소 누구나 좋아하는 무난하고 편안한 향', descZh: '男女老少皆宜的百搭舒适香气' },
      { icon: 'ri-leaf-line', titleKo: '천연 유래 성분', titleZh: '天然来源成分', descKo: '자연에서 유래한 순한 세정 성분으로 피부 보호', descZh: '来自自然的温和清洁成分，保护皮肤' },
    ],
  },
  {
    id: 'drHC20',
    code: 'No.HC20',
    name: '드레스룸 핸드크림 No.20 플라워샵 50ml',
    nameZh: 'W.DRESSROOM 护手霜 No.20 花店 50ml',
    category: '핸드크림',
    image: 'https://wdressroom.co.kr/web/product/big/202309/4c943980af8ad98c71be7c13a14ddfd4.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    hcRetailPrice: 65,
    hcLivePrice1: 39,
    hcLivePrice3: 99,
    hcCommission: 25,
    specification: '50ml',
    specificationZh: '50ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩국산',
    description: '드레스룸 핸드크림 No.20 플라워샵. 꽃집에 들어선 듯 싱그러운 생화 향이 가득한 네추럴 플로럴 향의 핸드크림입니다. 끈적임 없이 촉촉한 텍스쳐와 시어버터 함유로 건조함을 집중 케어하며, 향수 대용으로 사용할 수 있는 은은한 향기가 특징입니다.',
    descriptionZh: 'W.DRESSROOM护手霜No.20花店。充满如置身花店般清新生花香气的天然花香护手霜。无黏腻感的水润质地，含乳木果油集中护理干燥，散发可代替香水使用的淡雅香气。',
    keyFeatures: [
      { icon: 'ri-flower-line', titleKo: '플로럴 부케 향', titleZh: '花束香', descKo: '다양한 꽃들이 어우러진 싱그럽고 화사한 플로럴 향기', descZh: '多种花卉融合的清新明媚花香' },
      { icon: 'ri-heart-line', titleKo: '로맨틱 무드', titleZh: '浪漫氛围', descKo: '화사하고 로맨틱한 분위기를 연출하는 향기', descZh: '营造明媚浪漫氛围的香气' },
      { icon: 'ri-hand-heart-line', titleKo: '손 보습 케어', titleZh: '手部保湿护理', descKo: '건조한 손을 부드럽고 촉촉하게 가꿔주는 집중 보습', descZh: '集中保湿，让干燥双手变得柔软水润' },
    ],
  },
  {
    id: 'drHC20S',
    code: 'No.HC20S',
    name: '드레스룸 퍼퓸 핸드크림 50ml 세트',
    nameZh: 'W.DRESSROOM 香水护手霜 50ml 세트',
    category: '핸드크림',
    image: 'https://wdressroom.co.kr/web/product/big/202309/4c943980af8ad98c71be7c13a14ddfd4.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '50ml / 50ml',
    specificationZh: '50ml / 50ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended', 'popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    hcRetailPrice: 65,
    hcLivePrice1: 39,
    hcLivePrice3: 99,
    hcCommission: 25,
    description: '드레스룸 시그니처 퍼퓸 핸드크림 50ml 세트. 향수처럼 은은하게 퍼지는 고급 향기와 촉촉한 보습력을 동시에 즐길 수 있는 프리미엄 핸드크림입니다. 끈적임 없이 빠르게 흡수되며, 손을 부드럽고 촉촉하게 가꿔줍니다. 라이브 방송 최고 인기 상품으로 높은 커미션 수익을 자랑합니다.',
    descriptionZh: 'W.DRESSROOM标志性香水护手霜50ml套装。可同时享受如香水般淡雅散发的高级香气与滋润保湿力的高级护手霜。无黏腻感快速吸收，让双手柔软水润。直播间最热销商品，拥有高佣金收益。',
    keyFeatures: [
      { icon: 'ri-flower-line', titleKo: '퍼퓸 향기', titleZh: '香水香气', descKo: '향수처럼 은은하게 퍼지는 고급 퍼퓸 향기', descZh: '如香水般淡雅散发的高级香气' },
      { icon: 'ri-drop-line', titleKo: '빠른 흡수', titleZh: '快速吸收', descKo: '가볍고 촉촉한 제형으로 끈적임 없이 빠르게 흡수', descZh: '轻盈水润质地，无黏腻感快速吸收' },
      { icon: 'ri-percent-line', titleKo: '25% 고수익', titleZh: '25%高收益', descKo: '라이브 방송 최고 인기 상품, 25% 순수익 커미션', descZh: '直播间最热销商品，25%纯佣收益' },
    ],
  },
  {
    id: 'drHC30',
    code: 'No.HC30',
    name: '드레스룸 핸드크림 No.30 화이트 머스크 (백사향) 30ml',
    nameZh: 'W.DRESSROOM 护手霜 No.30 白麝香 (White Musk) 30ml',
    category: '핸드크림',
    image: 'https://wdressroom.co.kr/web/product/big/202202/ebd20892340c5b7eebaa639ce271f53a.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    hcRetailPrice: 55,
    hcLivePrice1: 29,
    hcLivePrice3: 79,
    hcCommission: 25,
    specification: '30ml',
    specificationZh: '30ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: '드레스룸 핸드크림 No.30 화이트 머스크. 깨끗하고 포근한 화이트 머스크 향이 피부에 은은하게 스며드는 핸드크림입니다. 세탁 후 갓 꺼낸 듯한 청결하고 부드러운 향기로 남녀노소 모두에게 사랑받는 베스트셀러 향입니다.',
    descriptionZh: 'W.DRESSROOM护手霜No.30白麝香。洁净温暖的白麝香淡雅渗入皮肤的护手霜。如刚洗完衣物般洁净柔和的香气，男女老少皆爱的畅销香型。',
    keyFeatures: [
      { icon: 'ri-sparkling-line', titleKo: '화이트 머스크 향', titleZh: '白麝香', descKo: '깨끗하고 포근한 화이트 머스크의 세련된 향기', descZh: '洁净温暖的白麝香优雅香气' },
      { icon: 'ri-user-heart-line', titleKo: '남녀 공용', titleZh: '男女通用', descKo: '남녀노소 누구나 좋아하는 무난하고 편안한 향', descZh: '男女老少皆宜的百搭舒适香气' },
      { icon: 'ri-hand-heart-line', titleKo: '손 보습 케어', titleZh: '手部保湿护理', descKo: '건조한 손을 부드럽고 촉촉하게 가꿔주는 집중 보습', descZh: '集中保湿，让干燥双手变得柔软水润' },
    ],
  },
  {
    id: 'drHC514',
    code: 'No.HC514',
    name: '드레스룸 핸드크림 No.514 5월의 장미 (메이 로즈) 30ml',
    nameZh: 'W.DRESSROOM 护手霜 No.514 五月玫瑰 (May Rose) 30ml',
    category: '핸드크림',
    image: 'https://wdressroom.co.kr/web/product/big/202405/60ba176ee2bc0ee5c59adf6c29b79077.jpg',
    unitPrice: 0,
    boxQuantity: 0,
    boxPrice: 0,
    hcRetailPrice: 55,
    hcLivePrice1: 29,
    hcLivePrice3: 79,
    hcCommission: 25,
    specification: '30ml',
    specificationZh: '30ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended', 'popular'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: '드레스룸 핸드크림 No.514 메이 로즈. 솜사탕처럼 포근하고 부드러운 코튼 향이 섬유에 스며들어 편안하고 아늑한 분위기를 연출합니다. 아이들 옷이나 침구에도 안심하고 사용할 수 있는 순한 향입니다.',
    descriptionZh: 'W.DRESSROOM护手霜No.514五月玫瑰。如棉花糖般温暖柔软的棉花香渗入织物，带来舒适温馨的感觉。儿童服装或床品也可安心使用的温和香气。',
    keyFeatures: [
      { icon: 'ri-flower-line', titleKo: '메이 로즈 향', titleZh: '五月玫瑰香', descKo: '5월 장미꽃의 싱그럽고 우아한 로즈 향기', descZh: '五月玫瑰清新优雅的玫瑰香气' },
      { icon: 'ri-heart-pulse-line', titleKo: '아이 옷 사용 가능', titleZh: '儿童衣物可用', descKo: '순한 성분으로 아이들 옷과 침구에도 안심 사용', descZh: '温和成分，儿童服装和床品也可安心使用' },
      { icon: 'ri-home-heart-line', titleKo: '아늑한 분위기', titleZh: '温馨氛围', descKo: '집에서 편안하고 아늑한 분위기를 연출하는 향', descZh: '在家营造舒适温馨氛围的香气' },
    ],
  },

  /* ───────── 스킨케어·뷰티 (라비엘) ───────── */
  {
    id: 'rvRV01',
    code: 'No.RV01',
    name: 'RAVIEL 기미잡티케어 크림 50ml+10ml',
    nameZh: 'RAVIEL Acerola 暗斑&瑕疵护理霜 (Blemish Care Cream)',
    category: '스킨케어·뷰티',
    image: 'https://public.readdy.ai/ai/img_res/326d38344d0793c7102cc76dbb137f71.jpg',
    unitPrice: 149,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '50ml + 10ml',
    specificationZh: '50ml + 10ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended', 'popular'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: '8차 완판 특가! 기미·잡티 케어와 톤 개선을 동시에 해결하는 RAVIEL 아세로라 크림입니다. 나이아신아마이드와 아세로라 추출물의 강력한 시너지로 피부 속 멜라닌 생성을 억제하고, 칙칙한 피부 톤을 환하게 밝혀줍니다. 50ml 본품 + 10ml 미니 구성.',
    descriptionZh: '第8次完售特价！RAVIEL Acerola暗斑&瑕疵护理霜，同时解决黑斑护理和提亮肤色。烟酰胺与维C精华的强力协同作用，抑制皮肤内黑色素生成，让暗沉肤色焕发光彩。50ml正装+10ml小样组合。',
    keyFeatures: [
      { icon: 'ri-sun-line', titleKo: '기미·잡티 케어', titleZh: '暗斑&瑕疵护理', descKo: '나이아신아마이드 성분이 멜라닌 생성을 억제하여 기미·잡티를 집중 케어', descZh: '烟酰胺成分抑制黑色素生成，集中护理暗斑瑕疵' },
      { icon: 'ri-sparkling-line', titleKo: '톤 개선 효과', titleZh: '提亮肤色效果', descKo: '아세로라 추출물의 비타민C가 칙칙한 피부 톤을 환하게 밝혀줌', descZh: '维C精华的维生素C让暗沉肤色焕发光彩' },
      { icon: 'ri-drop-line', titleKo: '보습·진정', titleZh: '保湿·舒缓', descKo: '풍부한 보습 성분으로 피부를 촉촉하게 유지하며 자극 없이 진정', descZh: '丰富保湿成分保持皮肤水润，无刺激舒缓肌肤' },
    ],
  },
  {
    id: 'rvRV02',
    code: 'No.RV02',
    name: 'RAVIEL 기미잡티케어 토너 150ml',
    nameZh: 'RAVIEL Acerola 暗斑&瑕疵护理爽肤水 (Blemish Care Toner)',
    category: '스킨케어·뷰티',
    image: 'https://readdy.ai/api/search-image?query=Korean%20luxury%20skincare%20brightening%20toner%20product%20photography%20elegant%20clear%20glass%20bottle%20with%20soft%20pink%20coral%20red%20acerola%20berry%20accent%20RAVIEL%20brand%20niacinamide%20vitamin%20C%20whitening%20blemish%20care%20toner%20150ml%20minimal%20clean%20packaging%20on%20pure%20white%20background%20studio%20shot%20high%20resolution&width=600&height=600&seq=rv02toner150ml2026&orientation=squarish',
    unitPrice: 169,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '150ml',
    specificationZh: '150ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: 'RAVIEL 아세로라 기미잡티케어 토너 150ml. 아세로라 추출물과 나이아신아마이드가 피부 깊숙이 침투하여 기미·잡티를 케어하고 피부 결을 정돈해 줍니다.',
    descriptionZh: 'RAVIEL Acerola暗斑&瑕疵护理爽肤水150ml。维C精华与烟酰胺深入渗透皮肤，护理暗斑瑕疵，整顿肤质。',
    keyFeatures: [
      { icon: 'ri-drop-line', titleKo: '깊은 침투 수분', titleZh: '深层渗透补水', descKo: '아세로라 성분이 피부 깊숙이 침투하여 수분을 공급', descZh: '维C精华深入渗透皮肤，充分补水' },
      { icon: 'ri-sun-line', titleKo: '기미·잡티 케어', titleZh: '暗斑&瑕疵护理', descKo: '나이아신아마이드로 멜라닌 생성 억제 및 기미 케어', descZh: '烟酰胺抑制黑色素生成，护理暗斑' },
      { icon: 'ri-leaf-line', titleKo: '피부결 정돈', titleZh: '整顿肤质', descKo: '피부 결을 부드럽게 정돈하여 다음 단계 흡수력 향상', descZh: '柔和整顿肤质，提升后续护肤品吸收力' },
    ],
  },
  {
    id: 'rvRV03',
    code: 'No.RV03',
    name: 'RAVIEL 기미잡티케어 앰플 30ml',
    nameZh: 'RAVIEL Acerola 暗斑&瑕疵护理安瓶 (Blemish Care Ampoule)',
    category: '스킨케어·뷰티',
    image: 'https://readdy.ai/api/search-image?query=Korean%20luxury%20skincare%20brightening%20ampoule%20serum%20product%20photography%20elegant%20small%20dropper%20bottle%20with%20soft%20pink%20coral%20red%20acerola%20berry%20accent%20RAVIEL%20brand%20niacinamide%20vitamin%20C%20whitening%20blemish%20care%20ampoule%2030ml%20minimal%20clean%20packaging%20on%20pure%20white%20background%20studio%20shot%20high%20resolution&width=600&height=600&seq=rv03ampoule30ml2026&orientation=squarish',
    unitPrice: 159,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '30ml',
    specificationZh: '30ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: 'RAVIEL 아세로라 기미잡티케어 앰플 30ml. 고농도 아세로라 추출물과 나이아신아마이드를 집중 배합한 앰플로, 기미·잡티에 직접 작용하여 빠른 효과를 제공합니다.',
    descriptionZh: 'RAVIEL Acerola暗斑&瑕疵护理安瓶30ml。高浓度维C精华与烟酰胺集中配合的安瓶，直接作用于暗斑瑕疵，快速见效。',
    keyFeatures: [
      { icon: 'ri-flask-line', titleKo: '고농도 집중 케어', titleZh: '高浓度集中护理', descKo: '고농도 아세로라 추출물로 기미·잡티에 직접 집중 작용', descZh: '高浓度维C精华直接集中作用于暗斑瑕疵' },
      { icon: 'ri-flashlight-line', titleKo: '빠른 효과', titleZh: '快速见效', descKo: '앰플 특유의 빠른 흡수력으로 즉각적인 효과 경험', descZh: '安瓶特有的快速吸收力，即时体验显著效果' },
      { icon: 'ri-sparkling-line', titleKo: '피부 광채', titleZh: '肌肤光彩', descKo: '칙칙한 피부 톤을 환하게 밝혀 건康한 광채 피부 완성', descZh: '让暗沉肤色焕发光彩，打造健康光泽肌肤' },
    ],
  },
  {
    id: 'rvRV04',
    code: 'No.RV04',
    name: 'RAVIEL 기미잡티케어 3종 세트 (토너+앰플+크림)',
    nameZh: 'RAVIEL Acerola Blemish & Dark Spot Care SET (Toner+Ampoule+Cream)',
    category: '스킨케어·뷰티',
    image: 'https://readdy.ai/api/search-image?query=Korean%20luxury%20skincare%20brightening%20three%20piece%20set%20product%20photography%20toner%20bottle%20ampoule%20dropper%20cream%20jar%20with%20soft%20pink%20coral%20red%20acerola%20berry%20accent%20RAVIEL%20brand%20niacinamide%20vitamin%20C%20whitening%20blemish%20care%20set%20minimal%20clean%20packaging%20on%20pure%20white%20background%20studio%20shot%20high%20resolution&width=600&height=600&seq=rv04set3pcs2026&orientation=squarish',
    unitPrice: 359,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '토너 150ml + 앰플 30ml + 크림 50ml',
    specificationZh: '爽肤水 150ml + 安瓶 30ml + 护理霜 50ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended', 'popular'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: 'RAVIEL 아세로라 기미잡티케어 3종 풀 세트. 토너(150ml) + 앰플(30ml) + 크림(50ml)으로 구성된 완벽한 기미·잡티 케어 루틴 세트입니다.',
    descriptionZh: 'RAVIEL Acerola暗斑&瑕疵护理3件套全套。由爽肤水(150ml)+安瓶(30ml)+护理霜(50ml)组成的完整暗斑护理套装。',
    keyFeatures: [
      { icon: 'ri-stack-line', titleKo: '3종 풀 세트', titleZh: '3件套全套', descKo: '토너+앰플+크림 3단계 완벽한 기미잡티케어 루틴', descZh: '爽肤水+安瓶+护理霜3步骤完整暗斑护理程序' },
      { icon: 'ri-price-tag-3-line', titleKo: '세트 할인', titleZh: '套装优惠', descKo: '개별 구매 대비 합리적인 세트 가격으로 경제적', descZh: '比单品购买更实惠的套装价格，经济实惠' },
      { icon: 'ri-award-line', titleKo: '시너지 효과', titleZh: '协同效果', descKo: '3단계 사용으로 각 제품의 효과를 극대화하는 시너지', descZh: '3步骤使用，最大化各产品效果的协同作用' },
    ],
  },
  {
    id: 'rvRV05',
    code: 'No.RV05',
    name: 'RAVIEL 기미잡티케어 크림 대용량 세트',
    nameZh: 'RAVIEL Acerola 暗斑&瑕疵护理霜 (Blemish Care Cream Set)',
    category: '스킨케어·뷰티',
    image: 'https://readdy.ai/api/search-image?query=Korean%20luxury%20skincare%20brightening%20cream%20large%20set%20product%20photography%20two%20big%20cream%20jars%20with%20soft%20pink%20coral%20red%20acerola%20berry%20accent%20RAVIEL%20brand%20niacinamide%20vitamin%20C%20whitening%20blemish%20care%20cream%20150ml%20set%20minimal%20clean%20packaging%20on%20pure%20white%20background%20studio%20shot%20high%20resolution&width=600&height=600&seq=rv05creamset150ml2026&orientation=squarish',
    unitPrice: 288,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '150ml × 2개 + 10ml × 1개',
    specificationZh: '150ml × 2个 + 10ml × 1个',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: 'RAVIEL 아세로라 기미잡티케어 크림 대용량 세트. 150ml 대용량 크림 2개 + 10ml 미니 1개 구성으로, 가족이 함께 사용하거나 장기간 사용하기에 최적화된 세트입니다.',
    descriptionZh: 'RAVIEL Acerola暗斑&瑕疵护理霜大容量套装。150ml大容量护理霜2个+10ml小样1个组合，最适合家庭共用或长期使用的套装。',
    keyFeatures: [
      { icon: 'ri-gift-line', titleKo: '대용량 세트', titleZh: '大容量套装', descKo: '150ml 대용량 2개 + 10ml 미니로 장기간 경제적 사용', descZh: '150ml大容量2个+10ml小样，长期经济实惠使用' },
      { icon: 'ri-sun-line', titleKo: '기미·잡티 케어', titleZh: '暗斑&瑕疵护理', descKo: '나이아신아마이드 성분이 멜라닌 생성을 억제하여 기미·잡티를 집중 케어', descZh: '烟酰胺成分抑制黑色素生成，集中护理暗斑瑕疵' },
      { icon: 'ri-sparkling-line', titleKo: '톤 개선 효과', titleZh: '提亮肤色效果', descKo: '아세로라 추출물의 비타민C가 칙칙한 피부 톤을 환하게 밝혀줌', descZh: '维C精华的维生素C让暗沉肤色焕发光彩' },
    ],
  },
  {
    id: 'rvRV06',
    code: 'No.RV06',
    name: 'RAVIEL 기미잡티케어 크림+앰플 세트',
    nameZh: '淡斑霜+淡斑安瓶 (Blemish Cream + Ampoule Set)',
    category: '스킨케어·뷰티',
    image: 'https://readdy.ai/api/search-image?query=Korean%20luxury%20skincare%20brightening%20cream%20ampoule%20duo%20set%20product%20photography%20cream%20jar%20and%20dropper%20bottle%20with%20soft%20pink%20coral%20red%20acerola%20berry%20accent%20RAVIEL%20brand%20niacinamide%20vitamin%20C%20whitening%20blemish%20care%20set%2050ml%2030ml%20minimal%20clean%20packaging%20on%20pure%20white%20background%20studio%20shot%20high%20resolution&width=600&height=600&seq=rv06creamampoule2026&orientation=squarish',
    unitPrice: 289,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '크림 50ml + 앰플 30ml',
    specificationZh: '护理霜 50ml + 安瓶 30ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: 'RAVIEL 기미잡티케어 크림(50ml) + 앰플(30ml) 듀오 세트. 고농도 앰플로 집중 케어 후 크림으로 마무리하는 2단계 기미잡티 케어 루틴 세트입니다.',
    descriptionZh: 'RAVIEL淡斑霜(50ml)+淡斑安瓶(30ml)双品套装。高浓度安瓶集中护理后用乳霜收尾的2步骤暗斑护理程序套装。',
    keyFeatures: [
      { icon: 'ri-flask-line', titleKo: '앰플+크림 듀오', titleZh: '安瓶+乳霜双品', descKo: '고농도 앰플과 크림의 2단계 집중 기미잡티 케어', descZh: '高浓度安瓶与乳霜2步骤集中暗斑护理' },
      { icon: 'ri-price-tag-3-line', titleKo: '세트 할인', titleZh: '套装优惠', descKo: '개별 구매 대비 합리적인 세트 가격', descZh: '比单品购买更实惠的套装价格' },
      { icon: 'ri-sparkling-line', titleKo: '시너지 효과', titleZh: '协同效果', descKo: '앰플과 크림의 조합으로 효과 극대화', descZh: '安瓶与乳霜组合，最大化护理效果' },
    ],
  },
  {
    id: 'rvRV07',
    code: 'No.RV07',
    name: 'RAVIEL 기미잡티케어 크림+토너 세트',
    nameZh: '淡斑霜+淡斑化妆水 (Blemish Cream + Toner Set)',
    category: '스킨케어·뷰티',
    image: 'https://readdy.ai/api/search-image?query=Korean%20luxury%20skincare%20brightening%20cream%20toner%20duo%20set%20product%20photography%20cream%20jar%20and%20toner%20bottle%20with%20soft%20pink%20coral%20red%20acerola%20berry%20accent%20RAVIEL%20brand%20niacinamide%20vitamin%20C%20whitening%20blemish%20care%20set%20150ml%2050ml%20minimal%20clean%20packaging%20on%20pure%20white%20background%20studio%20shot%20high%20resolution&width=600&height=600&seq=rv07creamtoner2026&orientation=squarish',
    unitPrice: 289,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '토너 150ml + 크림 50ml',
    specificationZh: '化妆水 150ml + 护理霜 50ml',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国有',
    description: 'RAVIEL 기미잡티케어 토너(150ml) + 크림(50ml) 듀오 세트. 토너로 피부를 정돈하고 크림으로 마무리하는 기본 2단계 기미잡티 케어 루틴 세트입니다.',
    descriptionZh: 'RAVIEL淡斑化妆水(150ml)+淡斑霜(50ml)双品套装。用化妆水整顿肤质后用乳霜收尾的基础2步骤暗斑护理程序套装。',
    keyFeatures: [
      { icon: 'ri-drop-line', titleKo: '토너+크림 듀오', titleZh: '化妆水+乳霜双品', descKo: '토너로 피부 정돈 후 크림으로 마무리하는 기본 케어 루틴', descZh: '化妆水整顿肤质后用乳霜收尾的基础护理程序' },
      { icon: 'ri-price-tag-3-line', titleKo: '세트 할인', titleZh: '套装优惠', descKo: '개별 구매 대비 합리적인 세트 가격', descZh: '比单品购买更实惠的套装价格' },
      { icon: 'ri-sun-line', titleKo: '기미·잡티 케어', titleZh: '暗斑&瑕疵护理', descKo: '나이아신아마이드와 아세로라로 기미·잡티 집중 케어', descZh: '烟酰胺与维C精华集中护理暗斑瑕疵' },
    ],
  },

  /* ───────── 스킨케어·뷰티 (베리썸) ───────── */
  {
    id: 'brBR01',
    code: 'No.BR01',
    name: 'berrisom 리얼 미 아이팔레트 01 로지무드',
    nameZh: 'berrisom 贝丽馨眼影盘 01 玫瑰情调',
    category: '스킨케어·뷰티',
    image: 'https://readdy.ai/api/search-image?query=Korean%20cosmetics%20eye%20shadow%20palette%20berrisom%20real%20me%20eye%20palette%20rosy%20mood%20pink%20rose%20tones%20compact%20square%20packaging%20elegant%20beauty%20product%20photography%20on%20clean%20white%20background%20studio%20lighting%20high%20resolution%20flat%20lay&width=600&height=600&seq=br01rosymood2026&orientation=squarish',
    unitPrice: 39.90,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '6.7g + 10g',
    specificationZh: '6.7g + 10g',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended', 'popular'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: 'berrisom 리얼 미 아이팔레트 01 로지무드 (玫瑰情调). 로맨틱하고 여성스러운 로즈 핑크 톤의 아이섀도 팔레트입니다. 데일리 메이크업부터 특별한 날의 화사한 눈매 연출까지 다양하게 활용 가능합니다.',
    descriptionZh: 'berrisom贝丽馨眼影盘01玫瑰情调。浪漫女性的玫瑰粉色调眼影盘。从日常妆容到特别场合的明媚眼妆均可多样运用。',
    keyFeatures: [
      { icon: 'ri-palette-line', titleKo: '로지무드 컬러', titleZh: '玫瑰情调色系', descKo: '로맨틱한 로즈 핑크 톤으로 여성스럽고 화사한 눈매 연출', descZh: '浪漫玫瑰粉色调，打造女性明媚眼妆' },
      { icon: 'ri-sparkling-line', titleKo: '발색력 우수', titleZh: '显色力优秀', descKo: '선명하고 오래 지속되는 발색으로 하루 종일 아름다운 눈매 유지', descZh: '鲜明持久的显色力，全天保持美丽眼妆' },
      { icon: 'ri-sun-line', titleKo: '데일리 메이크업', titleZh: '日常妆容', descKo: '데일리부터 특별한 날까지 다양하게 활용 가능한 팔레트', descZh: '从日常到特别场合均可多样运用的眼影盘' },
    ],
  },
  {
    id: 'brBR02',
    code: 'No.BR02',
    name: 'berrisom 리얼 미 아이팔레트 02 조이풀코랄',
    nameZh: 'berrisom 贝丽馨眼影盘 02 愉悦珊瑚',
    category: '스킨케어·뷰티',
    image: 'https://readdy.ai/api/search-image?query=Korean%20cosmetics%20eye%20shadow%20palette%20berrisom%20real%20me%20eye%20palette%20joyful%20coral%20orange%20coral%20warm%20tones%20compact%20square%20packaging%20elegant%20beauty%20product%20photography%20on%20clean%20white%20background%20studio%20lighting%20high%20resolution%20flat%20lay&width=600&height=600&seq=br02joyfulcoral2026&orientation=squarish',
    unitPrice: 39.90,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '6.7g + 10g',
    specificationZh: '6.7g + 10g',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: 'berrisom 리얼 미 아이팔레트 02 조이풀코랄 (愉悦珊瑚). 생기 넘치는 코랄 오렌지 톤의 아이섀도 팔레트로, 화사하고 건강한 눈매를 연출합니다.',
    descriptionZh: 'berrisom贝丽馨眼影盘02愉悦珊瑚。充满活力的珊瑚橙色调眼影盘，打造明媚健康的眼妆。',
    keyFeatures: [
      { icon: 'ri-palette-line', titleKo: '조이풀코랄 컬러', titleZh: '愉悦珊瑚色系', descKo: '생기 넘치는 코랄 오렌지 톤으로 건강하고 화사한 눈매 연출', descZh: '充满活力的珊瑚橙色调，打造健康明媚眼妆' },
      { icon: 'ri-sparkling-line', titleKo: '발색력 우수', titleZh: '显色力优秀', descKo: '선명하고 오래 지속되는 발색으로 하루 종일 아름다운 눈매 유지', descZh: '鲜明持久的显色力，全天保持美丽眼妆' },
      { icon: 'ri-sun-line', titleKo: '봄·여름 추천', titleZh: '春夏推荐', descKo: '봄·여름 시즌에 특히 잘 어울리는 생기 넘치는 코랄 컬러', descZh: '特别适合春夏季节的活力珊瑚色' },
    ],
  },
  {
    id: 'brBR03',
    code: 'No.BR03',
    name: 'berrisom 리얼 미 아이팔레트 03 뉴트럴그레이',
    nameZh: 'berrisom 贝丽馨眼影盘 03 中性灰色',
    category: '스킨케어·뷰티',
    image: 'https://readdy.ai/api/search-image?query=Korean%20cosmetics%20eye%20shadow%20palette%20berrisom%20real%20me%20eye%20palette%20neutral%20gray%20cool%20toned%20smoky%20grey%20silver%20tones%20compact%20square%20packaging%20elegant%20beauty%20product%20photography%20on%20clean%20white%20background%20studio%20lighting%20high%20resolution%20flat%20lay&width=600&height=600&seq=br03neutralgray2026&orientation=squarish',
    unitPrice: 39.90,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '6.7g + 10g',
    specificationZh: '6.7g + 10g',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: 'berrisom 리얼 미 아이팔레트 03 뉴트럴그레이 (中性灰色). 세련되고 시크한 그레이 톤의 아이섀도 팔레트로, 스모키 메이크업부터 내추럴 데일리 룩까지 다양하게 연출 가능합니다.',
    descriptionZh: 'berrisom贝丽馨眼影盘03中性灰色。时尚酷感的灰色调眼影盘，从烟熏妆到自然日常妆均可多样演绎。',
    keyFeatures: [
      { icon: 'ri-palette-line', titleKo: '뉴트럴그레이 컬러', titleZh: '中性灰色系', descKo: '세련된 그레이 톤으로 스모키부터 내추럴까지 다양한 연출', descZh: '时尚灰色调，从烟熏到自然妆均可多样演绎' },
      { icon: 'ri-men-line', titleKo: '남녀 공용', titleZh: '男女通用', descKo: '성별 구분 없이 누구나 활용 가능한 뉴트럴 컬러', descZh: '不分性别均可使用的中性色系' },
      { icon: 'ri-sparkling-line', titleKo: '발색력 우수', titleZh: '显色力优秀', descKo: '선명하고 오래 지속되는 발색으로 하루 종일 아름다운 눈매 유지', descZh: '鲜明持久的显色力，全天保持美丽眼妆' },
    ],
  },
  {
    id: 'brBR04',
    code: 'No.BR04',
    name: 'berrisom 리얼 미 아이팔레트 04 에센셜브라운',
    nameZh: 'berrisom 贝丽馨眼影盘 04 本质棕色',
    category: '스킨케어·뷰티',
    image: 'https://readdy.ai/api/search-image?query=Korean%20cosmetics%20eye%20shadow%20palette%20berrisom%20real%20me%20eye%20palette%20essential%20brown%20warm%20brown%20nude%20earth%20tones%20compact%20square%20packaging%20elegant%20beauty%20product%20photography%20on%20clean%20white%20background%20studio%20lighting%20high%20resolution%20flat%20lay&width=600&height=600&seq=br04essentialbrown2026&orientation=squarish',
    unitPrice: 39.90,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '6.7g + 10g',
    specificationZh: '6.7g + 10g',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保존',
    barcode: '',
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: 'berrisom 리얼 미 아이팔레트 04 에센셜브라운 (本质棕色). 따뜻하고 자연스러운 브라운 누드 톤의 아이섀도 팔레트로, 가장 무난하고 활용도 높은 데일리 팔레트입니다.',
    descriptionZh: 'berrisom贝丽馨眼影盘04本质棕色。温暖自然的棕色裸色调眼影盘，是最百搭、使用率最高的日常眼影盘。',
    keyFeatures: [
      { icon: 'ri-palette-line', titleKo: '에센셜브라운 컬러', titleZh: '本质棕色系', descKo: '따뜻한 브라운 누드 톤으로 가장 활용도 높은 데일리 팔레트', descZh: '温暖棕色裸色调，使用率最高的日常眼影盘' },
      { icon: 'ri-star-line', titleKo: '베스트셀러', titleZh: '畅销款', descKo: '가장 무난하고 인기 있는 에센셜 브라운 컬러', descZh: '最百搭最受欢迎的本质棕色系' },
      { icon: 'ri-sparkling-line', titleKo: '발색력 우수', titleZh: '显色力优秀', descKo: '선명하고 오래 지속되는 발색으로 하루 종일 아름다운 눈매 유지', descZh: '鲜明持久的显色力，全天保持美丽眼妆' },
    ],
  },

  /* ───────── 스킨케어·뷰티 (UVX) ───────── */
  {
    id: 'uvUV01',
    code: 'No.UV01',
    name: 'UVX 퀀텀 플루토 퍼퓸 선파우더',
    nameZh: 'UVX 量子冥王星香水防晒粉',
    category: '스킨케어·뷰티',
    image: 'https://readdy.ai/api/search-image?query=Korean%20luxury%20sunscreen%20powder%20compact%20UVX%20quantum%20pluto%20perfume%20sun%20powder%20SPF50%20PA%20%20%20%20%20elegant%20purple%20dark%20space%20galaxy%20themed%20compact%20packaging%20beauty%20product%20photography%20on%20clean%20white%20background%20studio%20lighting%20high%20resolution&width=600&height=600&seq=uv01sunpowder2026&orientation=squarish',
    unitPrice: 39.90,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '4g / 支',
    specificationZh: '4g / 支',
    expiryInfo: '제조일로부터 36개월',
    expiryInfoZh: '自生产日起36个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended', 'popular'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: 'UVX 퀀텀 플루토 퍼퓸 선파우더 (量子冥王星香水防晒粉). 향수 향기와 자외선 차단 기능을 동시에 갖춘 혁신적인 선파우더입니다. 4g 소용량으로 휴대가 간편하며, 메이크업 위에 덧바를 수 있어 외출 중 간편한 자외선 차단 및 피부 보정이 가능합니다.',
    descriptionZh: 'UVX量子冥王星香水防晒粉。同时具备香水香气与防晒功能的创新防晒粉。4g小容量携带方便，可叠涂于妆容之上，外出时轻松防晒并修饰肌肤。',
    keyFeatures: [
      { icon: 'ri-sun-line', titleKo: '자외선 차단', titleZh: '防晒功能', descKo: '강력한 자외선 차단 성분으로 피부를 UV로부터 보호', descZh: '强效防晒成分，保护皮肤免受紫外线伤害' },
      { icon: 'ri-contrast-drop-line', titleKo: '퍼퓸 향기', titleZh: '香水香气', descKo: '플루토 시그니처 향기가 자외선 차단과 함께 은은하게 지속', descZh: '冥王星标志性香气与防晒功能同时持久留存' },
      { icon: 'ri-map-pin-line', titleKo: '휴대 간편', titleZh: '携带方便', descKo: '4g 소용량 컴팩트 설계로 가방에 넣어 언제 어디서나 간편 사용', descZh: '4g小容量紧凑设计，放入包中随时随地方便使用' },
    ],
  },

  /* ───────── 생활용품 ───────── */
  {
    id: 'bBL03',
    code: 'No.BL03',
    name: '아이순애 프리미엄 물티슈 72장',
    nameZh: 'WORAM纯爱宝宝湿巾',
    category: '생활용품',
    image: 'https://i.ibb.co/HpTgsnzB/35.jpg',
    unitPrice: 6,
    boxQuantity: 8,
    boxPrice: 48,
    specification: '72장 * 8개/박스',
    specificationZh: '72张 * 8个/箱',
    expiryInfo: '제조일로부터 24개월',
    expiryInfoZh: '自生产日起24个月',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '6974866430025',
    tags: ['recommended', 'lowest'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
  },

  /* ───────── 운동화 (월드런) ───────── */
  {
    id: 'wrWR01',
    code: 'No.WR01',
    name: '월드런 슈플라이트3',
    nameZh: 'WORLDRUN 超轻跑鞋3代',
    category: '운동화',
    image: 'https://readdy.ai/api/search-image?query=Korean%20professional%20marathon%20running%20shoe%20fluorescent%20yellow%20green%20white%20lightweight%20breathable%20mesh%20upper%20cushioned%20sole%20athletic%20footwear%20side%20view%20white%20background%20clean%20product%20photography%20high%20resolution&width=600&height=600&seq=wr01main&orientation=squarish',
    unitPrice: 130,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '남녀공용 / 사이즈 선택',
    specificationZh: '男女通用 / 尺码可选',
    expiryInfo: '-',
    expiryInfoZh: '-',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '1772064785',
    retailPrice: 159000,
    tags: ['recommended', 'popular'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国有',
    description: '최고의 운동화, 가볍고 빠르다! 월드런 슈플라이트3는 극한의 경량화와 반발력을 동시에 구현한 마라톤·레이싱 전용 러닝화입니다. 5km부터 풀마라톤까지 모든 거리에서 탁월한 성능을 발휘합니다.',
    descriptionZh: '消费者价格 ₩159,000 | 终极轻量化与强劲反弹力的马拉松·竞速专用跑鞋！WORLDRUN超轻跑鞋3代，从5km到全程马拉松，在所有距离都能发挥卓越性能。',
    keyFeatures: [
      { icon: 'ri-speed-line', titleKo: '경량 설계', titleZh: '极致轻量', descKo: '극한의 경량 소재로 발이 가볍게 느껴지는 레이싱 전용 설계', descZh: '极致轻量材质，专为竞速设计，感受如飞般轻盈' },
      { icon: 'ri-arrow-up-double-line', titleKo: '강한 반발력', titleZh: '强劲反弹', descKo: '고탄성 쿠션 밑창으로 착지 충격을 줄이고 추진력 향상', descZh: '高弹性缓冲鞋底，减缓落地冲击并增强推进力' },
      { icon: 'ri-run-line', titleKo: '전 거리 대응', titleZh: '全程适用', descKo: '5km 단거리부터 풀마라톤까지 모든 레이스에 최적화', descZh: '从5km短跑到全程马拉松，适合所有赛程' },
    ],
  },
  {
    id: 'wrWR02',
    code: 'No.WR02',
    name: '월드런 슈플라이트2 블랙',
    nameZh: 'WORLDRUN 超轻跑鞋2代 黑色',
    category: '운동화',
    image: 'https://readdy.ai/api/search-image?query=Korean%20professional%20marathon%20running%20shoe%20black%20dark%20colorway%20lightweight%20mesh%20breathable%20carbon%20plate%20sole%20athletic%20performance%20footwear%20side%20view%20white%20background%20clean%20product%20photography&width=600&height=600&seq=wr02main&orientation=squarish',
    unitPrice: 130,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '남녀공용 / 사이즈 선택',
    specificationZh: '男女通用 / 尺码可选',
    expiryInfo: '-',
    expiryInfoZh: '-',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '1740456647',
    retailPrice: 99000,
    tags: ['popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '성공적인 당신의 첫 카본화! 무선으로 달리는 슈플라이트의 위력, 전국 매장이 없도 오직 성능으로 구준히 사랑받고 있는 월드런의 성능을 세계에 배포하세요. 블랙 에디션으로 레이싱의 강렬함을 더욱 돋보이게.',
    descriptionZh: '消费者价格 ₩99,000 | 成功人士的首款碳板跑鞋！凭借卓越性能赢得全国跑者青睐的WORLDRUN，黑色版本让你在赛场上更加耀眼夺目。',
    keyFeatures: [
      { icon: 'ri-award-line', titleKo: '카본 플레이트', titleZh: '碳板科技', descKo: '초경량 카본 플레이트 내장으로 에너지 리턴 극대화', descZh: '内置超轻碳板，最大化能量回归' },
      { icon: 'ri-contrast-2-line', titleKo: '블랙 에디션', titleZh: '黑色版本', descKo: '세련된 블랙 컬러로 레이싱의 강렬한 존재감 연출', descZh: '优雅黑色，展现赛场上强烈的存在感' },
      { icon: 'ri-shield-line', titleKo: '내구성 강화', titleZh: '强化耐久性', descKo: '신생아 피부의 자연 보호막을 강화하여 외부 자극 차단', descZh: '强化新生儿皮肤天然保护膜，阻隔外部刺激' },
    ],
  },
  {
    id: 'wrWR03',
    code: 'No.WR03',
    name: '월드런 베플라이트2',
    nameZh: 'WORLDRUN 倍轻跑鞋2代',
    category: '운동화',
    image: 'https://readdy.ai/api/search-image?query=Korean%20professional%20marathon%20running%20shoe%20white%20pink%20yellow%20gradient%20colorway%20lightweight%20breathable%20mesh%20upper%20rainbow%20sole%20athletic%20performance%20footwear%20side%20view%20white%20background%20product%20photography&width=600&height=600&seq=wr03main&orientation=squarish',
    unitPrice: 130,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '남녀공용 / 사이즈 선택',
    specificationZh: '男女通用 / 尺码可选',
    expiryInfo: '-',
    expiryInfoZh: '-',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '1732084341',
    retailPrice: 99000,
    tags: ['recommended'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: '슈플라이트2는 전 세대 대비 쿠션감을 대폭 강화하면서도 무게를 줄인 업그레이드 버전입니다. 화이트/핑크/옐로우 컬러로 활기찬 러닝을 즐겨보세요.',
    descriptionZh: '消费者价格 ₩99,000 | 升级版超轻跑鞋！第2代在上一代基础上大幅强化缓冲感的同时降低了重量。白色/粉色/黄色配色，享受充满活力的跑步体验。',
    keyFeatures: [
      { icon: 'ri-contrast-drop-line', titleKo: '업그레이드 쿠션', titleZh: '升级缓冲', descKo: '전 세대 대비 40% 강화된 쿠션감으로 장거리 피로 감소', descZh: '与上一代相比缓冲提升40%，减少长跑疲劳' },
      { icon: 'ri-palette-line', titleKo: '화이트/핑크/옐로우', titleZh: '白/粉/黄配色', descKo: '활기차고 세련된 컬러로 달리는 즐거움을 더하는 디자인', descZh: '充满活力的时尚配色，增添跑步乐趣' },
      { icon: 'ri-heart-pulse-line', titleKo: '발 건강 설계', titleZh: '足部健康设计', descKo: '인체공학적 설계로 발목 부담을 최소화하는 스마트 설계', descZh: '人体工学设计，最大限度减少踝关节负担' },
    ],
  },
  {
    id: 'wrWR04',
    code: 'No.WR04',
    name: '월드런 베플라이트2',
    nameZh: 'WORLDRUN 倍轻跑鞋2代',
    category: '운동화',
    image: 'https://readdy.ai/api/search-image?query=Korean%20professional%20marathon%20running%20shoe%20white%20beige%20cream%20lightweight%20breathable%20knit%20upper%20colorful%20gradient%20heel%20counter%20athletic%20performance%20footwear%20side%20view%20white%20background%20product%20photography&width=600&height=600&seq=wr04main&orientation=squarish',
    unitPrice: 130,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '남녀공용 / 사이즈 선택',
    specificationZh: '男女通用 / 尺码可选',
    expiryInfo: '-',
    expiryInfoZh: '-',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '1732084316',
    retailPrice: 119000,
    tags: ['recommended', 'popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '월드런 베플라이트2는 베테랑 러너와 입문자 모두를 위한 균형 잡힌 트레이닝화입니다. 적절한 쿠션과 반발력, 안정적인 착화감이 특징이며, 일상 훈련부터 하프마라톤까지 폭넓게 활용 가능합니다.',
    descriptionZh: '消费者价格 ₩119,000 | 倍轻跑鞋2代是为资深跑者和入门者均适用的均衡训练跑鞋。适当的缓冲与反弹力、稳定的穿着感为特点，从日常训练到半程马拉松均可广泛使用。',
    keyFeatures: [
      { icon: 'ri-scales-line', titleKo: '균형잡힌 성능', titleZh: '均衡性能', descKo: '쿠션·반발력·안정성의 완벽한 균형으로 모든 페이스에 대응', descZh: '缓冲·反弹·稳定性完美均衡，应对所有配速' },
      { icon: 'ri-user-line', titleKo: '입문자~고수', titleZh: '新手到高手', descKo: '러닝 입문자부터 베테랑까지 모두에게 적합한 범용 트레이닝화', descZh: '从跑步入门者到资深跑者均适合的通用训练跑鞋' },
      { icon: 'ri-road-map-line', titleKo: '다용도 활용', titleZh: '多用途使用', descKo: '일상 훈련, 하프 레이싱, 10km 대회 등 폭넓게 활용 가능', descZh: '日常训练、半程马拉松、10km比赛等广泛适用' },
    ],
  },
  {
    id: 'wrWR05',
    code: 'No.WR05',
    name: '월드런 카본Z4',
    nameZh: 'WORLDRUN 碳Z4竞速跑鞋',
    category: '운동화',
    image: 'https://readdy.ai/api/search-image?query=Korean%20professional%20marathon%20running%20shoe%20bright%20blue%20turquoise%20carbon%20fiber%20plate%20lightweight%20breathable%20mesh%20upper%20competitive%20racing%20footwear%20side%20view%20white%20background%20clean%20product%20photography%20high%20resolution&width=600&height=600&seq=wr05main&orientation=squarish',
    unitPrice: 130,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '270size 기준 204g / 사이즈 선택',
    specificationZh: '270码基准204g / 尺码可选',
    expiryInfo: '-',
    expiryInfoZh: '-',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '1746057667',
    retailPrice: 99000,
    tags: ['recommended', 'popular'],
    badge: '인기',
    badgeZh: '热销',
    origin: '한국산',
    originZh: '韩国产',
    description: '270사이즈 기준 204g의 초경량! 5k, 10k, 하프 레이싱 초보자·중급자 추천. 카본 원단 사용으로 1m 두께의 부드러운 카본을 구현했으며, 아웃솔 내구성이 강한 천연 고무를 사용해 오래 신을 수 있습니다.',
    descriptionZh: '消费者价格 ₩99,000 | 270码基准仅204g的超轻量级！推荐5K、10K、半马初级·中级跑者。采用碳纤维面料实现1m厚度的柔软碳材，外底使用耐久性强的天然橡胶，经久耐用。',
    keyFeatures: [
      { icon: 'ri-scales-3-line', titleKo: '204g 초경량', titleZh: '204g超轻量', descKo: '270사이즈 기준 204g의 극한 경량화 실현', descZh: '270码基准实现204g的极致轻量化' },
      { icon: 'ri-grid-line', titleKo: '카본 원단', titleZh: '碳纤维面料', descKo: '고급 카본 원단으로 경량성과 강도를 동시에 구현', descZh: '高级碳纤维面料同时实现轻量性与强度' },
      { icon: 'ri-leaf-fill', titleKo: '천연 고무 아웃솔', titleZh: '天然橡胶外底', descKo: '내구성 강한 천연 고무 아웃솔로 장기 사용 가능', descZh: '耐久性强的天然橡胶外底，可长期使用' },
    ],
  },

  /* ───────── 생활용품 (아이스 넥밴드) ───────── */
  {
    id: 'nbNB01',
    code: 'No.NB01',
    name: '아이스 넥밴드 (28°C 자동 냉각)',
    nameZh: '冰凉颈带 (28°C自动冷却)',
    category: '생활용품',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/1f107953-0c05-4873-bea5-b5c2b1419e32_333.png?v=9b8d790383e13ce9befde64680fdc685',
    unitPrice: 0,
    retailPrice: 30000,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '남녀공용 / 프리사이즈',
    specificationZh: '男女通用 / 均码',
    expiryInfo: '-',
    expiryInfoZh: '-',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended', 'popular'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: '28°C에서 자동으로 얼어버리는 신기한 아이스 넥밴드! 상변화 물질(PCM) 기술을 적용하여 기온이 28°C 이하로 내려가면 자동으로 굳어 냉각 효과를 발휘합니다. 냉동고 없이도 실온에서 자연 충전되며, 목에 걸치기만 해도 즉각적인 시원함을 느낄 수 있습니다. 여름 야외활동, 스포츠, 출퇴근 시 필수 아이템입니다.',
    descriptionZh: '在28°C自动结冻的神奇冰凉颈带！采用相变材料(PCM)技术，当气温降至28°C以下时自动凝固发挥冷却效果。无需冷冻，在室温下自然充能，只需挂在脖子上即可立即感受清凉。是夏季户外活动、运动、上下班的必备单品。',
    keyFeatures: [
      { icon: 'ri-temp-cold-line', titleKo: '28°C 자동 냉각', titleZh: '28°C自动冷却', descKo: '상변화 물질(PCM) 기술로 28°C 이하에서 자동으로 굳어 냉각 시작', descZh: '相变材料(PCM)技术，28°C以下自动凝固开始冷却' },
      { icon: 'ri-refresh-line', titleKo: '실온 자연 충전', titleZh: '室温自然充能', descKo: '냉동고 없이 실온에서 자연스럽게 재충전, 반영구적 사용 가능', descZh: '无需冷冻，室温自然再充能，可半永久使用' },
      { icon: 'ri-run-line', titleKo: '야외활동 필수템', titleZh: '户外活动必备', descKo: '가볍고 유연한 소재로 운동·야외활동·출퇴근 시 편리하게 착용', descZh: '轻盈柔韧材质，运动·户外活动·上下班均可方便佩戴' },
    ],
  },

  /* ───────── 건강용품 (건일바이오) ───────── */
  {
    id: 'giGI01',
    code: 'No.GI01',
    name: '건일 다기능 발매트 깔창',
    nameZh: '健一多功能足垫鞋垫',
    category: '건강용품',
    image: 'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/17046554-197e-4cae-9ad1-859c5edfa174_123.jpg?v=83c5e822043b0b9018fc07aaf2f1a4da',
    unitPrice: 46,
    retailPrice: 80000,
    boxQuantity: 0,
    boxPrice: 0,
    specification: '남녀공용 / 프리사이즈',
    specificationZh: '男女通用 / 均码',
    expiryInfo: '-',
    expiryInfoZh: '-',
    storageMethod: '상온보관',
    storageMethodZh: '常温保存',
    barcode: '',
    tags: ['recommended', 'popular'],
    badge: '추천',
    badgeZh: '推荐',
    origin: '한국산',
    originZh: '韩国产',
    description: '체형교정 기능을 갖는 건일바이오의 다기능 발매트 깔창입니다. 특허번호 제10-1765192호, 디자인등록 제30-0782820호, 실용신안등록 제20-0481956호를 보유한 정품입니다. 발매트 깔창은 보행 중 뒤꿈치·앞부분에서 충격을 흡수하고, 중앙은 발바닥과 밀착되어 발의 피로감을 절감할 수 있도록 하였습니다. 발바닥 외측으로 갈수록 높게 형성하여 무릎이 안쪽으로 모이도록 하여 오다리의 체형을 교정할 수 있도록 한 체형교정용 발매트입니다. 공기가 순환되도록 홈으로써 발의 땀을 제거하여 발냄새를 억제할 수 있도록 한 통풍구를 포함합니다. 원적외선 방사율 91.1% (한국건생활환경시험연구원).',
    descriptionZh: '具有体型矫正功能的健一生物多功能足垫鞋垫。持有专利号第10-1765192号、外观设计注册第30-0782820号、实用新型注册第20-0481956号的正品。足垫鞋垫在行走过程中吸收脚跟和前部的冲击，中央部分与脚底紧密贴合，减轻脚部疲劳。向脚底外侧逐渐升高，使膝盖向内聚拢，矫正O型腿体型的体型矫正用足垫。包含通过凹槽促进空气循环、去除脚汗、抑制脚臭的通风孔。远红外线放射率91.1%（韩国生活环境试验研究院）。',
    keyFeatures: [
      { icon: 'ri-body-scan-line', titleKo: '체형교정 기능', titleZh: '体型矫正功能', descKo: '오다리 교정 및 무릎 정렬을 돕는 특허받은 체형교정 설계', descZh: '获专利的体型矫正设计，帮助矫正O型腿及膝关节对齐' },
      { icon: 'ri-shield-check-line', titleKo: '충격 흡수', titleZh: '冲击吸收', descKo: '뒤꿈치·앞부분 충격 흡수 및 발바닥 밀착으로 피로 절감', descZh: '吸收脚跟和前部冲击，与脚底紧密贴合，减轻疲劳' },
      { icon: 'ri-heart-pulse-line', titleKo: '통풍·탈취', titleZh: '通风除臭', descKo: '통풍구 설계로 공기 순환 및 발냄새 억제, 원적외선 방사율 91.1%', descZh: '通风孔设计促进空气循环，抑制脚臭，远红外线放射率91.1%' },
    ],
  },
];

export const recommendedProducts = products.filter(p => p.tags.includes('recommended'));
export const lowestPriceProducts = products.filter(p => p.tags.includes('lowest'));
export const popularProducts = products.filter(p => p.tags.includes('popular'));

export const categories = ['스킨케어·뷰티', '섬유향수', '핸드크림', '탕류', '해조류', '음료·두유', '차류', '스낵·김', '생활용품', '김치·반찬', '운동화', '건강용품'] as const;
export type Category = typeof categories[number];

// 식품 그룹 - 탕류·해조류·음료·두유·차류·스낵·김·김치·반찬
export const FOOD_CATEGORIES: Category[] = ['탕류', '해조류', '음료·두유', '차류', '스낵·김', '김치·반찬'];

// 상위 카테고리 그룹 (헤더/탭에서 사용)
export interface CategoryGroup {
  id: string;
  ko: string;
  zh: string;
  children?: Category[];
}

export const categoryGroups: CategoryGroup[] = [
  { id: '스킨케어·뷰티', ko: '스킨케어·뷰티', zh: '护肤·美妆', children: ['섬유향수', '핸드크림', '스킨케어·뷰티'] },
  { id: 'food', ko: '식품', zh: '食品', children: ['탕류', '해조류', '음료·두유', '차류', '스낵·김', '김치·반찬'] },
  { id: '생활용품', ko: '생활용품', zh: '生活用品' },
  { id: '운동화', ko: '운동화', zh: '运动鞋' },
  { id: '건강용품', ko: '건강용품', zh: '健康用品' },
];